import React, { useState, useEffect, useCallback, useRef } from 'react';
import { View, Text, StyleSheet, Pressable, TextInput, Dimensions, ScrollView, Icon3 } from '../lib/react-native-compat';
import { isLiveVersionAtom, selectedJobAtom, ohPercentAtom, selectedJobDataAtom, overheadDataAtom, selectedVersionLockedAtom, userNameAtom, userIdAtom, dataSourceJobsAtom } from '../store/company';
import { useAtom } from 'jotai';
import { updateUserDataArray, loadUserData, f, fNum, pNum, sum, cN, deleteCO, deleteUserData, loadTeamUserDataMain } from '../db/company';
import {
    jobUserDataAtom,
    selectedVersionAtom
} from '../store/company';
import { NumberInput } from './numberInput';
import XLSX from 'xlsx';
import { buildCOLogRows } from '../helpers/cologRows';

const COLog = (a) => {
    const cologRef = useRef()
    const [selectedJob, setSelectedJob] = useAtom(selectedJobAtom)
    const [selectedVersion, setSelectedVersion] = useAtom(selectedVersionAtom);
    const [jobs] = useAtom(dataSourceJobsAtom);
    const [headersOnly, setHeadersOnly] = useState(false)
    const [ohPercent, setOhPercent] = useAtom(ohPercentAtom)
    const [lockedVersion, setLockedVersion] = useAtom(selectedVersionLockedAtom)
    const [userName] = useAtom(userNameAtom);
    const [userId] = useAtom(userIdAtom);
    const [isExporting, setIsExporting] = useState(false)
    const [isUploading, setIsUploading] = useState(false)
    const [isCopying, setIsCopying] = useState(false)
    const [coLogs, setCOLogs] = useState([])
    const [coLogsImage, setCOLogsImage] = useState([])
    const sectionRefs = useRef([])
    const [laborExpanded, setLaborExpanded] = useState(false)
    const [equipmentExpanded, setEquipmentExpanded] = useState(false)
    const [materialsExpanded, setMaterialsExpanded] = useState(false)
    const [subsExpanded, setSubsExpanded] = useState(false)
    const [otherExpanded, setOtherExpanded] = useState(false)
    const [unitsExpanded, setUnitsExpanded] = useState(false)
    const [totalExpanded, setTotalExpanded] = useState(false)
    const [sortField, setSortField] = useState('Row_Label') // Default sort by CO Number
    const [sortDirection, setSortDirection] = useState('asc') // 'asc' or 'desc'

    useEffect(() => {
        if (coLogs.length > 0) {
            const sortedData = sortData([...coLogs]);
            setCOLogs(sortedData);
            setCOLogsImage(divideIntoSections(sortedData));
        }
    }, [sortField, sortDirection]);

    const sortData = (data) => {
        return data.sort((a, b) => {
            let aVal, bVal;

            // Handle different sort fields
            switch (sortField) {
                case 'Row_Label':
                    aVal = a.Row_Label || '';
                    bVal = b.Row_Label || '';
                    // For Row_Label, treat as numbers if possible
                    if (!isNaN(parseInt(aVal)) && !isNaN(parseInt(bVal))) {
                        aVal = parseInt(aVal);
                        bVal = parseInt(bVal);
                    }
                    break;
                case 'id':
                    aVal = a.id || '';
                    bVal = b.id || '';
                    // For id, treat as numbers if possible
                    if (!isNaN(parseInt(aVal)) && !isNaN(parseInt(bVal))) {
                        aVal = parseInt(aVal);
                        bVal = parseInt(bVal);
                    }
                    break;
                default:
                    aVal = a[sortField] || '';
                    bVal = b[sortField] || '';
            }

            // Handle empty values - push to end
            if (!aVal && aVal !== 0) return 1;
            if (!bVal && bVal !== 0) return -1;

            let comparison = 0;
            if (aVal > bVal) comparison = 1;
            if (aVal < bVal) comparison = -1;

            // Apply sort direction
            return sortDirection === 'desc' ? -comparison : comparison;
        });
    };

    const [totalAddersToBudgetQty, setTotalAddersToBudgetQty] = useState('-')
    const [totalBudgetQty, setTotalBudgetQty] = useState('-')

    const [totalUnitPrice, setTotalUnitPrice] = useState('-')
    const [totalTAndM, setTotalTAndM] = useState('-')
    const [totalChangeOrders, setTotalChangeOrders] = useState('-')
    const [totalReductionOfScope, setTotalReductionOfScope] = useState('-')
    const [totalTotalRevenue, setTotalTotalRevenue] = useState('-')
    const [totalLabor, setTotalLabor] = useState('-')
    const [totalEquipment, setTotalEquipment] = useState('-')
    const [totalMaterials, setTotalMaterials] = useState('-')
    const [totalMaterialsTotal, setTotalMaterialsTotal] = useState('-')
    const [totalSubs, setTotalSubs] = useState('-')
    const [totalOther, setTotalOther] = useState('-')
    const [totalTotalCosts, setTotalTotalCosts] = useState('-')
    const [totalGrossProfit, setTotalGrossProfit] = useState('-')
    const [totalGpPercent, setTotalGpPercent] = useState('-')
    const [totalTotalLaborHours, setTotalTotalLaborHours] = useState('-')
    const [totalRegularTime, setTotalRegularTime] = useState('-')
    const [totalOvertime, setTotalOvertime] = useState('-')
    const [totalBurden, setTotalBurden] = useState('-')
    const [totalByod, setTotalByod] = useState('-')
    const [totalPerDiem, setTotalPerDiem] = useState('-')
    const [totalTruckPay, setTotalTruckPay] = useState('-')
    const [totalWeldingRigPay, setTotalWeldingRigPay] = useState('-')
    const [totalFieldBonus, setTotalFieldBonus] = useState('-')
    const [totalTotalQty, setTotalTotalQty] = useState('-')
    const [totalTotalEquipmentHours, setTotalTotalEquipmentHours] = useState('-')
    const [totalInsideEquipmentRentals, setTotalInsideEquipmentRentals] = useState('-')
    const [totalOutsideEquipmentRentals, setTotalOutsideEquipmentRentals] = useState('-')
    const [totalFuel, setTotalFuel] = useState('-')
    const [totalRepairs, setTotalRepairs] = useState('-')
    const [totalMats, setTotalMats] = useState('-')
    const [totalToolsSupplies, setTotalToolsSupplies] = useState('-')
    const [totalSkids, setTotalSkids] = useState('-')
    const [totalInternalSubs, setTotalInternalSubs] = useState('-')
    const [totalExternalSubs, setTotalExternalSubs] = useState('-')
    const [totalHaulingTransportation, setTotalHaulingTransportation] = useState('-')
    const [totalPersonalMeals, setTotalPersonalMeals] = useState('-')
    const [totalTeamMealsEntertain, setTotalTeamMealsEntertain] = useState('-')
    const [totalAirfare, setTotalAirfare] = useState('-')
    const [totalLodging, setTotalLodging] = useState('-')
    const [totalFieldOfficeRent, setTotalFieldOfficeRent] = useState('-')
    const [totalFieldOfficeUtility, setTotalFieldOfficeUtility] = useState('-')
    const [totalFieldOfficeExpense, setTotalFieldOfficeExpense] = useState('-')
    const [totalLabFeesTesting, setTotalLabFeesTesting] = useState('-')
    const [totalSafetyPPE, setTotalSafetyPPE] = useState('-')
    const [totalBondsInsurancePremiums, setTotalBondsInsurancePremiums] = useState('-')
    const [totalPermits, setTotalPermits] = useState('-')
    const [totalInsuranceClaims, setTotalInsuranceClaims] = useState('-')
    const [totalTaxes, setTotalTaxes] = useState('-')
    const [totalAccruedExpenses, setTotalAccruedExpenses] = useState('-')
    const [totalWarrantyReserve, setTotalWarrantyReserve] = useState('-')
    const [totalMisc, setTotalMisc] = useState('-')
    const [totalOtherTravelExpenses, setTotalOtherTravelExpenses] = useState('-')
    const [totalOverhead, setTotalOverhead] = useState('-')

    const [totalUnitPriceApproved, setTotalUnitPriceApproved] = useState('-')
    const [totalTAndMApproved, setTotalTAndMApproved] = useState('-')
    const [totalChangeOrdersApproved, setTotalChangeOrdersApproved] = useState('-')
    const [totalReductionOfScopeApproved, setTotalReductionOfScopeApproved] = useState('-')
    const [totalTotalRevenueApproved, setTotalTotalRevenueApproved] = useState('-')
    const [totalLaborApproved, setTotalLaborApproved] = useState('-')
    const [totalEquipmentApproved, setTotalEquipmentApproved] = useState('-')
    const [totalMaterialsApproved, setTotalMaterialsApproved] = useState('-')
    const [totalMaterialsTotalApproved, setTotalMaterialsTotalApproved] = useState('-')
    const [totalSubsApproved, setTotalSubsApproved] = useState('-')
    const [totalOtherApproved, setTotalOtherApproved] = useState('-')
    const [totalTotalCostsApproved, setTotalTotalCostsApproved] = useState('-')
    const [totalGrossProfitApproved, setTotalGrossProfitApproved] = useState('-')
    const [totalGpPercentApproved, setTotalGpPercentApproved] = useState('-')
    const [totalTotalLaborHoursApproved, setTotalTotalLaborHoursApproved] = useState('-')
    const [totalRegularTimeApproved, setTotalRegularTimeApproved] = useState('-')
    const [totalOvertimeApproved, setTotalOvertimeApproved] = useState('-')
    const [totalBurdenApproved, setTotalBurdenApproved] = useState('-')
    const [totalByodApproved, setTotalByodApproved] = useState('-')
    const [totalPerDiemApproved, setTotalPerDiemApproved] = useState('-')
    const [totalTruckPayApproved, setTotalTruckPayApproved] = useState('-')
    const [totalWeldingRigPayApproved, setTotalWeldingRigPayApproved] = useState('-')
    const [totalFieldBonusApproved, setTotalFieldBonusApproved] = useState('-')
    const [totalTotalQtyApproved, setTotalTotalQtyApproved] = useState('-')
    const [totalTotalEquipmentHoursApproved, setTotalTotalEquipmentHoursApproved] = useState('-')
    const [totalInsideEquipmentRentalsApproved, setTotalInsideEquipmentRentalsApproved] = useState('-')
    const [totalOutsideEquipmentRentalsApproved, setTotalOutsideEquipmentRentalsApproved] = useState('-')
    const [totalFuelApproved, setTotalFuelApproved] = useState('-')
    const [totalRepairsApproved, setTotalRepairsApproved] = useState('-')
    const [totalMatsApproved, setTotalMatsApproved] = useState('-')
    const [totalToolsSuppliesApproved, setTotalToolsSuppliesApproved] = useState('-')
    const [totalSkidsApproved, setTotalSkidsApproved] = useState('-')
    const [totalInternalSubsApproved, setTotalInternalSubsApproved] = useState('-')
    const [totalExternalSubsApproved, setTotalExternalSubsApproved] = useState('-')
    const [totalHaulingTransportationApproved, setTotalHaulingTransportationApproved] = useState('-')
    const [totalPersonalMealsApproved, setTotalPersonalMealsApproved] = useState('-')
    const [totalTeamMealsEntertainApproved, setTotalTeamMealsEntertainApproved] = useState('-')
    const [totalAirfareApproved, setTotalAirfareApproved] = useState('-')
    const [totalLodgingApproved, setTotalLodgingApproved] = useState('-')
    const [totalFieldOfficeRentApproved, setTotalFieldOfficeRentApproved] = useState('-')
    const [totalFieldOfficeUtilityApproved, setTotalFieldOfficeUtilityApproved] = useState('-')
    const [totalFieldOfficeExpenseApproved, setTotalFieldOfficeExpenseApproved] = useState('-')
    const [totalLabFeesTestingApproved, setTotalLabFeesTestingApproved] = useState('-')
    const [totalSafetyPPEApproved, setTotalSafetyPPEApproved] = useState('-')
    const [totalBondsInsurancePremiumsApproved, setTotalBondsInsurancePremiumsApproved] = useState('-')
    const [totalPermitsApproved, setTotalPermitsApproved] = useState('-')
    const [totalInsuranceClaimsApproved, setTotalInsuranceClaimsApproved] = useState('-')
    const [totalTaxesApproved, setTotalTaxesApproved] = useState('-')
    const [totalAccruedExpensesApproved, setTotalAccruedExpensesApproved] = useState('-')
    const [totalWarrantyReserveApproved, setTotalWarrantyReserveApproved] = useState('-')
    const [totalMiscApproved, setTotalMiscApproved] = useState('-')
    const [totalOtherTravelExpensesApproved, setTotalOtherTravelExpensesApproved] = useState('-')
    const [totalOverheadApproved, setTotalOverheadApproved] = useState('-')

    const [totalUnitPricePending, setTotalUnitPricePending] = useState('-')
    const [totalTAndMPending, setTotalTAndMPending] = useState('-')
    const [totalChangeOrdersPending, setTotalChangeOrdersPending] = useState('-')
    const [totalReductionOfScopePending, setTotalReductionOfScopePending] = useState('-')
    const [totalTotalRevenuePending, setTotalTotalRevenuePending] = useState('-')
    const [totalLaborPending, setTotalLaborPending] = useState('-')
    const [totalEquipmentPending, setTotalEquipmentPending] = useState('-')
    const [totalMaterialsPending, setTotalMaterialsPending] = useState('-')
    const [totalMaterialsTotalPending, setTotalMaterialsTotalPending] = useState('-')
    const [totalSubsPending, setTotalSubsPending] = useState('-')
    const [totalOtherPending, setTotalOtherPending] = useState('-')
    const [totalTotalCostsPending, setTotalTotalCostsPending] = useState('-')
    const [totalGrossProfitPending, setTotalGrossProfitPending] = useState('-')
    const [totalGpPercentPending, setTotalGpPercentPending] = useState('-')
    const [totalTotalLaborHoursPending, setTotalTotalLaborHoursPending] = useState('-')
    const [totalRegularTimePending, setTotalRegularTimePending] = useState('-')
    const [totalOvertimePending, setTotalOvertimePending] = useState('-')
    const [totalBurdenPending, setTotalBurdenPending] = useState('-')
    const [totalByodPending, setTotalByodPending] = useState('-')
    const [totalPerDiemPending, setTotalPerDiemPending] = useState('-')
    const [totalTruckPayPending, setTotalTruckPayPending] = useState('-')
    const [totalWeldingRigPayPending, setTotalWeldingRigPayPending] = useState('-')
    const [totalFieldBonusPending, setTotalFieldBonusPending] = useState('-')
    const [totalTotalQtyPending, setTotalTotalQtyPending] = useState('-')
    const [totalTotalEquipmentHoursPending, setTotalTotalEquipmentHoursPending] = useState('-')
    const [totalInsideEquipmentRentalsPending, setTotalInsideEquipmentRentalsPending] = useState('-')
    const [totalOutsideEquipmentRentalsPending, setTotalOutsideEquipmentRentalsPending] = useState('-')
    const [totalFuelPending, setTotalFuelPending] = useState('-')
    const [totalRepairsPending, setTotalRepairsPending] = useState('-')
    const [totalMatsPending, setTotalMatsPending] = useState('-')
    const [totalToolsSuppliesPending, setTotalToolsSuppliesPending] = useState('-')
    const [totalSkidsPending, setTotalSkidsPending] = useState('-')
    const [totalInternalSubsPending, setTotalInternalSubsPending] = useState('-')
    const [totalExternalSubsPending, setTotalExternalSubsPending] = useState('-')
    const [totalHaulingTransportationPending, setTotalHaulingTransportationPending] = useState('-')
    const [totalPersonalMealsPending, setTotalPersonalMealsPending] = useState('-')
    const [totalTeamMealsEntertainPending, setTotalTeamMealsEntertainPending] = useState('-')
    const [totalAirfarePending, setTotalAirfarePending] = useState('-')
    const [totalLodgingPending, setTotalLodgingPending] = useState('-')
    const [totalFieldOfficeRentPending, setTotalFieldOfficeRentPending] = useState('-')
    const [totalFieldOfficeUtilityPending, setTotalFieldOfficeUtilityPending] = useState('-')
    const [totalFieldOfficeExpensePending, setTotalFieldOfficeExpensePending] = useState('-')
    const [totalLabFeesTestingPending, setTotalLabFeesTestingPending] = useState('-')
    const [totalSafetyPPEPending, setTotalSafetyPPEPending] = useState('-')
    const [totalBondsInsurancePremiumsPending, setTotalBondsInsurancePremiumsPending] = useState('-')
    const [totalPermitsPending, setTotalPermitsPending] = useState('-')
    const [totalInsuranceClaimsPending, setTotalInsuranceClaimsPending] = useState('-')
    const [totalTaxesPending, setTotalTaxesPending] = useState('-')
    const [totalAccruedExpensesPending, setTotalAccruedExpensesPending] = useState('-')
    const [totalWarrantyReservePending, setTotalWarrantyReservePending] = useState('-')
    const [totalMiscPending, setTotalMiscPending] = useState('-')
    const [totalOtherTravelExpensesPending, setTotalOtherTravelExpensesPending] = useState('-')
    const [totalOverheadPending, setTotalOverheadPending] = useState('-')

    const [jobUserData, setJobUserData] = useAtom(jobUserDataAtom);
    const [isLiveVersion, setIsLiveVersion] = useAtom(isLiveVersionAtom);
    const [selectedJobData, setSelectedJobData] = useAtom(selectedJobDataAtom);
    const [coRows, setCORows] = useState([])
    const [coSections, setCOSections] = useState([])
    const [customerViewSections, setCustomerViewSections] = useState([])
    const [pageWidth, setPageWidth] = useState(Dimensions.get('window').width);
    const [file, setFile] = useState(null);
    const [fileLong, setFileLong] = useState(null);
    const fileInput = useRef(null);
    const focusedId = useRef(null)

    // Border width constant for table styling
    const bw = StyleSheet.hairlineWidth;

    // Color constants for PSR View table styling
    const COLORS = {
        grid: '#e2e8f0',
        white: '#ffffff',
        rowHighlight: '#fef3c7',
        zebra: '#f9fafb',
        cellText: '#1e293b'
    };

    useEffect(() => {
        if (selectedJob && selectedVersion) {
            loadUserData({ id: selectedJob, forecastGuid: selectedVersion, live: isLiveVersion }).then((data) => {
                setJobUserData(data?.data);
            })
        }
    }, [selectedJob, selectedVersion, isLiveVersion]);

    const divideIntoSections = (logs) => {
        let sections = [];
        const sectionSize = 20;
        //console.log('logs', logs, sectionSize)
        for (let i = 0; i < logs.length; i += sectionSize) {
            //console.log('adding section', logs.slice(i, i + sectionSize))
            sections.push(logs.slice(i, i + sectionSize));
        }
        return sections;
    }

    useEffect(() => {
        if (jobUserData && jobUserData.length > 0) {
            setupPage();
        }
    }, [jobUserData, ohPercent])

    useEffect(() => {
        if (a.photo && customerViewSections) {
            // Create refs for all sections, but filter for PSR slide job
            customerViewSections.forEach((_, index) => {
                if (!sectionRefs.current[index]) {
                    sectionRefs.current[index] = React.createRef();
                }
            });
            a.setJobRef(a.job, 'coLog', sectionRefs.current)
        }
    }, [coLogsImage]);

    const CORow = ({
        highlighted,
        header,
        id }) => {
        const data = header ? coSections.find(d => d.id === id) : coLogs.find((d) => d.id === id)

        const [rowId, setRowId] = useState(id ? id : Math.random().toString(20).slice(2).substring(0, 9))
        const [coNo, setCoNo] = useState(data?.Row_Label ? data?.Row_Label : '')
        const [phase, setPhase] = useState(data?.Cost_Code ? data?.Cost_Code : '')
        const [itemDescription, setItemDescription] = useState(data?.Description ? data?.Description : '')
        const [status, setStatus] = useState(data?.status ? data?.status : data?.Status ? data?.Status : '')
        const [unitPrice, setUnitPrice] = useState(data?.unitPrice ? f(data?.unitPrice) : '')
        const [tAndM, setTAndM] = useState(data?.tAndM ? f(data?.tAndM) : '')
        const [changeOrders, setChangeOrders] = useState(data?.changeOrders ? f(data?.changeOrders) : '')
        const [reductionOfScope, setReductionOfScope] = useState(data?.reductionOfScope ? f(data?.reductionOfScope) : '')
        const [totalRevenue, setTotalRevenue] = useState(data?.totalRevenue ? data?.totalRevenue : '')
        const [labor, setLabor] = useState(data?.labor ? data?.labor : '')
        const [equipment, setEquipment] = useState(data?.equipment ? data?.equipment : '')
        const [materials, setMaterials] = useState(data?.[53100] ? f(data?.[53100]) : '')
        const [subs, setSubs] = useState(data?.subs ? f(data?.subs) : '')
        const [materialsTotal, setMaterialsTotal] = useState(data?.materialsTotal ? data?.materialsTotal : '')
        const [otherExpenses, setOtherExpenses] = useState(data?.otherExpenses ? data?.otherExpenses : '')
        const [totalCosts, setTotalCosts] = useState(data?.totalCosts ? data?.totalCosts : '')
        const [grossProfit, setGrossProfit] = useState(data?.grossProfit ? data?.grossProfit : '')
        const [gpPercent, setGpPercent] = useState(data?.gpPercent ? data?.gpPercent : '')
        const [additionalNotes, setAdditionalNotes] = useState(data?.Notes ? data?.Notes : '')
        const [budgetQty, setBudgetQty] = useState(data?.budgetQty ? f(data?.budgetQty) : '')
        const [regularTime, setRegularTime] = useState(data?.[51100] ? f(data?.[51100]) : '')
        const [overtime, setOvertime] = useState(data?.[51200] ? f(data?.[51200]) : '')
        const [burden, setBurden] = useState(data?.[51300] ? f(data?.[51300]) : '')
        const [byod, setByod] = useState(data?.[51400] ? f(data?.[51400]) : '')
        const [perDiem, setPerDiem] = useState(data?.[51500] ? f(data?.[51500]) : '')
        const [truckPay, setTruckPay] = useState(data?.[51600] ? f(data?.[51600]) : '')
        const [weldingRigPay, setWeldingRigPay] = useState(data?.[51700] ? f(data?.[51700]) : '')
        const [fieldBonus, setFieldBonus] = useState(data?.[51800] ? f(data?.[51800]) : '')
        const [totalLaborHours, setTotalLaborHours] = useState(data?.Hours ? f(data?.Hours) : '')
        const [totalEquipmentHours, setTotalEquipmentHours] = useState(data?.totalEquipmentHours ? f(data?.totalEquipmentHours) : '')
        const [insideEquipmentRentals, setInsideEquipmentRentals] = useState(data?.[52100] ? f(data?.[52100]) : '')
        const [outsideEquipmentRentals, setOutsideEquipmentRentals] = useState(data?.[52200] ? f(data?.[52200]) : '')
        const [fuel, setFuel] = useState(data?.[52300] ? f(data?.[52300]) : '')
        const [repairs, setRepairs] = useState(data?.[52400] ? f(data?.[52400]) : '')
        const [mats, setMats] = useState(data?.[53200] ? f(data?.[53200]) : '')
        const [toolsSupplies, setToolsSupplies] = useState(data?.[53300] ? f(data?.[53300]) : '')
        const [skids, setSkids] = useState(data?.[53400] ? f(data?.[53400]) : '')
        const [internalSubs, setInternalSubs] = useState(data?.[54100] ? f(data?.[54100]) : '')
        const [externalSubs, setExternalSubs] = useState(data?.[54200] ? f(data?.[54200]) : '')
        const [haulingTransportation, setHaulingTransportation] = useState(data?.[54300] ? f(data?.[54300]) : '')
        const [personalMeals, setPersonalMeals] = useState(data?.[55100] ? f(data?.[55100]) : '')
        const [teamMealsEntertain, setTeamMealsEntertain] = useState(data?.[55200] ? f(data?.[55200]) : '')
        const [airfare, setAirfare] = useState(data?.[55300] ? f(data?.[55300]) : '')
        const [lodging, setLodging] = useState(data?.[55400] ? f(data?.[55400]) : '')
        const [fieldOfficeRent, setFieldOfficeRent] = useState(data?.[56100] ? f(data?.[56100]) : '')
        const [fieldOfficeUtility, setFieldOfficeUtility] = useState(data?.[56200] ? f(data?.[56200]) : '')
        const [fieldOfficeExpense, setFieldOfficeExpense] = useState(data?.[56300] ? f(data?.[56300]) : '')
        const [labFeesTesting, setLabFeesTesting] = useState(data?.[56400] ? f(data?.[56400]) : '')
        const [safetyPPE, setSafetyPPE] = useState(data?.[56500] ? f(data?.[56500]) : '')
        const [bondsInsurancePremiums, setBondsInsurancePremiums] = useState(data?.[56600] ? f(data?.[56600]) : '')
        const [permits, setPermits] = useState(data?.[56700] ? f(data?.[56700]) : '')
        const [insuranceClaims, setInsuranceClaims] = useState(data?.[56800] ? f(data?.[56800]) : '')
        const [taxes, setTaxes] = useState(data?.[57100] ? f(data?.[57100]) : '')
        const [accruedExpenses, setAccruedExpenses] = useState(data?.[57200] ? f(data?.[57200]) : '')
        const [warrantyReserve, setWarrantyReserve] = useState(data?.[57300] ? f(data?.[57300]) : '')
        const [misc, setMisc] = useState(data?.[57900] ? f(data?.[57900]) : '')
        const [otherTravelExpenses, setOtherTravelExpenses] = useState(data?.[55900] ? f(data?.[55900]) : '')
        const [overhead, setOverhead] = useState(fNum(data?.totalRevenue ? data?.totalRevenue * pNum(ohPercent) / 100 : 0))
        const [isFocus, setIsFocus] = useState(false)
        const inputsRef = useRef([])
        const [localFocusedId, setLocalFocusedId] = useState(focusedId.current)
        const changeListRef = useRef([]);

        useEffect(() => {
            // if (inputsRef.current[localFocusedId]) {
            //     inputsRef.current[localFocusedId].focus();
            //     const val = inputsRef.current[localFocusedId].value
            //     inputsRef.current[localFocusedId].value = ''
            //     inputsRef.current[localFocusedId].value = val
            // }
        }, [localFocusedId])

        useEffect(() => {
            const l = pNum(labor)
            const e = pNum(equipment)
            const m = pNum(materialsTotal)
            const s = pNum(subs)
            const o = pNum(otherExpenses)
            const oh = pNum(overhead)
            setTotalCosts(fNum(l + e + m + s + o + oh))

        }, [labor, equipment, materials, subs, otherExpenses, overhead])

        useEffect(() => {
            const tR = pNum(totalRevenue)
            const tC = pNum(totalCosts)
            setOverhead(fNum(tR * pNum(ohPercent) / 100))
            setGrossProfit(fNum(tR - tC))
        }, [totalRevenue, totalCosts])

        useEffect(() => {
            const gP = pNum(grossProfit)
            const tR = pNum(totalRevenue)
            if (tR === 0 || isNaN(gP / tR)) {
                setGpPercent('-')
            } else {
                setGpPercent(fNum(((gP / tR) * 100).toFixed()) + '%')
            }
        }, [grossProfit, totalRevenue])

        useEffect(() => {
            const iER = pNum(insideEquipmentRentals.floatValue)
            const oER = pNum(outsideEquipmentRentals.floatValue)
            const f = pNum(fuel.floatValue)
            const r = pNum(repairs.floatValue)

            setEquipment(fNum(iER + oER + f + r))
        }, [insideEquipmentRentals, outsideEquipmentRentals, fuel, repairs])

        useEffect(() => {
            const m = pNum(mats.floatValue)
            const mts = pNum(materials.floatValue)
            const tS = pNum(toolsSupplies.floatValue)
            const s = pNum(skids.floatValue)

            setMaterialsTotal(fNum(m + mts + tS + s))
        }, [materials, mats, toolsSupplies, skids])

        useEffect(() => {
            const rT = pNum(regularTime.floatValue)
            const oT = pNum(overtime.floatValue)
            const b = pNum(burden.floatValue)
            const bY = pNum(byod.floatValue)
            const pD = pNum(perDiem.floatValue)
            const tP = pNum(truckPay.floatValue)
            const wRP = pNum(weldingRigPay.floatValue)
            const fB = pNum(fieldBonus.floatValue)
            setLabor(fNum(rT + oT + b + bY + pD + tP + wRP + fB))
        }, [regularTime, overtime, burden, byod, perDiem, truckPay, weldingRigPay, fieldBonus])

        useEffect(() => {
            const iS = pNum(internalSubs.floatValue)
            const eS = pNum(externalSubs.floatValue)
            const hT = pNum(haulingTransportation.floatValue)
            setSubs(fNum(iS + eS + hT))
        }, [internalSubs, externalSubs, haulingTransportation])

        useEffect(() => {
            const pM = pNum(personalMeals.floatValue)
            const tM = pNum(teamMealsEntertain.floatValue)
            const a = pNum(airfare.floatValue)
            const l = pNum(lodging.floatValue)
            const fOR = pNum(fieldOfficeRent.floatValue)
            const fOU = pNum(fieldOfficeUtility.floatValue)
            const fOE = pNum(fieldOfficeExpense.floatValue)
            const lFT = pNum(labFeesTesting.floatValue)
            const sPPE = pNum(safetyPPE.floatValue)
            const bIP = pNum(bondsInsurancePremiums.floatValue)
            const p = pNum(permits.floatValue)
            const iC = pNum(insuranceClaims.floatValue)
            const t = pNum(taxes.floatValue)
            const aE = pNum(accruedExpenses.floatValue)
            const wR = pNum(warrantyReserve.floatValue)
            const m = pNum(misc.floatValue)
            const oT = pNum(otherTravelExpenses.floatValue)
            setOtherExpenses(fNum(pM + tM + a + l + fOR + fOU + fOE + lFT + sPPE + bIP + p + iC + t + aE + wR + m + oT))
        }, [personalMeals, teamMealsEntertain, airfare, lodging, fieldOfficeRent, fieldOfficeUtility, fieldOfficeExpense, labFeesTesting, safetyPPE, bondsInsurancePremiums, permits, insuranceClaims, taxes, accruedExpenses, warrantyReserve, misc, otherTravelExpenses])

        useEffect(() => {
            const d = [
                cN(unitPrice.floatValue),
                cN(tAndM.floatValue),
                cN(changeOrders.floatValue),
                cN(reductionOfScope.floatValue)
            ]
            setTotalRevenue(fNum(sum(d)))
        }, [unitPrice, tAndM, changeOrders, reductionOfScope])

        const debounce = (func, delay) => {
            let timeoutId;
            return (...args) => {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                timeoutId = setTimeout(() => {
                    func(...args);
                }, delay);
            };
        }

        const debounceSave = useCallback(
            debounce(() => {
                console.log('here in save', changeListRef.current);
                saveValues(changeListRef.current);
                changeListRef.current = [];
            }, 2000),
            []
        );

        const handleInputChange = (value, key) => {
            changeListRef.current.push({ key: key, value: value });
            debounceSave();
        };

        const saveValues = (values) => {
            const uData = JSON.parse(JSON.stringify(coLogs))
            console.log('save values', values, uData, rowId)
            if (values.length > 0) {
                const keysSeen = {};
                const filteredValues = [];
                for (let i = values.length - 1; i >= 0; i--) {
                    const { key } = values[i];
                    if (!keysSeen[key]) {
                        keysSeen[key] = true;
                        filteredValues.unshift(values[i]);
                    }
                }
                filteredValues.forEach(v => {
                    const value = v.value;
                    const key = v.key;

                    let data = {
                        userId: userId || 'seth.bailey@strikeusa.com',
                        userName: userName || 'Seth Bailey',
                        fieldName: v.key,
                        tab: "CO Log",
                        rowId: rowId,
                        version: selectedVersion + '',
                        value: v.value + '',
                        valueAmount: isNaN(pNum(v.value)) ? '' : pNum(v.value),
                        costCode: v.key === 'phase' ? v.value : phase,
                        costType: isNaN(pNum(v.key)) ? '' : pNum(v.key),
                        id: selectedJob,
                        description: status,
                        notes: v.key == 'additionalNotes' ? v.value : additionalNotes,
                        rowLabel: key === 'coNo' ? value : coNo,
                        description: key === 'itemDescription' ? value : itemDescription,
                        quantity: key === 'Quantity' ? value : budgetQty?.formattedValue,
                        hours: key === 'totalLaborHours' ? value : totalLaborHours?.formattedValue,
                        status: key === 'status' ? value : status,
                        lockedVersion: lockedVersion
                    };
                    updateUserDataArray(data);
                    //syncToJDE(data);

                    if (
                        key === 'coNo' ||
                        key === 'itemDescription' ||
                        key === 'Quantity' ||
                        key === 'totalLaborHours' ||
                        key === 'status' ||
                        key === 'additionalNotes' ||
                        key === 'phase'
                    ) {
                        // Update all rows in userData with the same rowId but different fieldName
                        Object.values(jobUserData || []).forEach((row) => {
                            if (
                                (row.Forecast_Row_ID === rowId || row.id === rowId) &&
                                row.Forecast_Field_Name !== key
                            ) {
                                // Go through all fields in row and set undefined to empty string
                                let updateD = { ...row };
                                let updatedD = {}
                                Object.keys(updateD).forEach(field => {
                                    if (updateD[field] == "undefined") {
                                        updateD[field] = '';
                                    }
                                    // Map database field names to the correct database keys for saving
                                    // Example mapping: { Description: 'itemDescription', Notes: 'additionalNotes', Row_Label: 'coNo', ... }

                                    const dbFieldMap = {
                                        'BU_ID': 'id',
                                        'Forecast_Row_ID': 'rowId',
                                        'Forecast_Field_Name': 'fieldName',
                                        'Forecast_Tab': 'tab',
                                        'Forecast_Value': 'value',
                                        'Forecast_Datetime': 'forecastDate',
                                        'Forecast_Updated_By': 'userId',
                                        'Forecast_Updated_Datetime': 'updatedDate',
                                        'Resource_Code': 'resourceCode',
                                        //'Cost_Code': 'phase',
                                        'Cost_Type': 'costType',
                                        'Value_Amount': 'valueAmount',
                                        'Project_Start': 'projectStart',
                                        'Project_End': 'projectEnd',
                                        'Phase_Start': 'phaseStart',
                                        'Phase_End': 'phaseEnd',
                                        'Rate': 'rate',
                                        'Number_Hours': 'numberHours',
                                        'Number_Units': 'numberUnits',
                                        'Active': 'active',
                                        'Version_GUID': 'version',
                                        'Quantity': 'budgetQty'
                                        // Add more mappings as needed
                                    };

                                    // For each field, use the mapping if available, otherwise use the original field
                                    if (updateD[field] != null && updateD[field] != '') {
                                        const dbField = dbFieldMap[field] || field;
                                        updatedD[dbField] = updateD[field];
                                    }
                                });
                                const updateData = {
                                    ...updatedD,
                                    //updateRow: 1,
                                    //guidId: row.Forecast_User_Data_GUID + '',
                                    description: key === 'itemDescription' ? value : row.Description,
                                    notes: key === 'additionalNotes' ? value : row.Notes,
                                    rowLabel: key === 'coNo' ? value : row.Row_Label,
                                    quantity: key === 'Quantity' ? value : row.Quantity,
                                    hours: key === 'totalLaborHours' ? value : row.Hours,
                                    status: key === 'status' ? value : row.Status,
                                    costCode: key === 'phase' ? value : row.Cost_Code
                                };

                                console.log('updateData', updateData);
                                updateUserDataArray(updateData);
                                //syncToJDE(updateData);
                            }
                        });
                    }

                    let notFound = true;
                    uData.forEach((log) => {
                        if (log.id === rowId) {
                            log[key] = value;
                            if (key == 'additionalNotes') {
                                log['Notes'] = value;
                            } else if (key === 'coNo') {
                                log['Row_Label'] = value;
                            } else if (key === 'phase') {
                                log['Cost_Code'] = value;
                            } else if (key === 'itemDescription') {
                                log['Description'] = value;
                            } else if (key === 'status') {
                                log['Status'] = value;
                            } else if (key === 'totalLaborHours') {
                                log['Hours'] = value;
                            } else if (key === 'Quantity') {
                                log['Quantity'] = value;
                                log['budgetQty'] = value;
                            }
                            notFound = false;
                        }
                    });

                    if (notFound) {
                        let newLog = {
                            id: rowId,
                            [key]: value
                        };
                        if (key == 'additionalNotes') {
                            newLog['Notes'] = value;
                        } else if (key === 'coNo') {
                            newLog['Row_Label'] = value;
                        } else if (key === 'phase') {
                            newLog['Cost_Code'] = value;
                        } else if (key === 'itemDescription') {
                            newLog['Description'] = value;
                        } else if (key === 'status') {
                            newLog['Status'] = value;
                        } else if (key === 'totalLaborHours') {
                            newLog['Hours'] = value;
                        } else if (key === 'Quantity') {
                            newLog['Quantity'] = value;
                            newLog['budgetQty'] = value;
                        }
                        uData.push(newLog);
                    }
                });
            }

            const compare = (a, b) => {
                if (!a.Row_Label) return 1;  // If a.Row_Label is blank, push it to the end
                if (!b.Row_Label) return -1; // If b.Row_Label is blank, push it to the end

                return parseInt(a.Row_Label) > parseInt(b.Row_Label) ? 1 : -1;
            };

            console.log('updated user data co', uData)
            const sortedData = sortData(uData);
            setCOLogs(sortedData)
            setCOLogsImage(divideIntoSections(sortedData))
            calculateTotals(uData)
        }

        const statusOptions = [
            { label: 'Approved', value: 'Approved' },
            { label: 'Pending - Performed', value: 'Pending - Performed' },
            { label: 'Pending - Not Performed', value: 'Pending - Not Performed' },
            { label: 'Not Submitted', value: 'Not Submitted' },
            { label: 'Denied', value: 'Denied' },
            { label: 'Passthru', value: 'Passthru' }
        ]

        const deleteRow = () => {
            let uData = JSON.parse(JSON.stringify(coLogs))
            uData = uData.filter((log) => log.id !== rowId)
            coRows.forEach((row) => {
                if (row.Forecast_Row_ID === id) {
                    deleteUserData({ id: selectedJob, forecastGuid: selectedVersion, lockedVersion: lockedVersion, rowId: row.Forecast_User_Data_GUID + '', tab: 'CO Log' })
                }
            })
            setCOLogs(uData)
            setCOLogsImage(divideIntoSections(uData))
            calculateTotals(uData)
        }


        return (
            <View style={s().container}>
                {!header ? <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <TextInput style={highlighted ? s(80).span1T : s(80).spanT}
                        ref={e => { inputsRef.current[rowId + '-coNo'] = e }}
                        onFocus={() => { focusedId.current = rowId + '-coNo' }}  // Track the input when focused
                        value={coNo}
                        onChangeText={(t) => {
                            setCoNo(t)
                            handleInputChange(t, 'coNo')
                            setLocalFocusedId(rowId + '-coNo')
                        }}>
                    </TextInput>
                </View> : <Text style={s(80).spanT}>{coNo}</Text>}
                {!header ? <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <TextInput style={highlighted ? s(80).span1T : s(80).spanT}
                        ref={e => { inputsRef.current[rowId + '-phase'] = e }}
                        onFocus={() => { focusedId.current = rowId + '-phase' }}  // Track the input when focused
                        value={phase}
                        onChangeText={(t) => {
                            setPhase(t)
                            handleInputChange(t, 'phase')
                            setLocalFocusedId(rowId + '-phase')
                        }}>
                    </TextInput>
                </View> : <Text style={s(80).spanT}>{phase}</Text>}
                {!header ? <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <TextInput style={highlighted ? s(300).span1T : s(300).spanT}
                        ref={e => { inputsRef.current[rowId + '-itemDescription'] = e }}
                        onFocus={() => { focusedId.current = rowId + '-itemDescription' }}  // Track the input when focused
                        value={itemDescription}
                        onChangeText={(t) => {
                            setItemDescription(t)
                            handleInputChange(t, 'itemDescription')
                            setLocalFocusedId(rowId + '-itemDescription')
                        }}>
                    </TextInput>
                </View> : <Text style={s(300).spanT}>{itemDescription}</Text>}
                {!header ? <select
                    style={{
                        width: 200,
                        borderWidth: 1,
                        borderColor: highlighted ? '#FFD700' : '#ccc',
                        borderStyle: 'solid',
                        padding: 8,
                        borderRadius: 4,
                        backgroundColor: highlighted ? '#FFF8DC' : '#fff'
                    }}
                    value={status}
                    onFocus={() => setIsFocus(true)}
                    onBlur={() => setIsFocus(false)}
                    onChange={(e) => {
                        setStatus(e.target.value);
                        setIsFocus(false);
                        handleInputChange(e.target.value, 'status')
                    }}
                >
                    <option value="">Select Status</option>
                    {statusOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select> : <Text style={s(200).spanT}>{status}</Text>}
                <View style={{ width: 20 }}></View>
                {/* <TextInput style={highlighted ? s().span1T : s().spanT}
                    value={budgetQty}
                    onChangeText={(t) => {
                        setBudgetQty(t)
                        saveValue(t, 'budgetQty')
                    }}>
                </TextInput>
                <TextInput style={highlighted ? s().span1T : s().spanT}
                    value={original$}
                    onChangeText={(t) => {
                        setOriginal$(t)
                        saveValue(t, 'original$')
                    }}>
                </TextInput>
                <TextInput style={highlighted ? s().span1T : s().spanT}
                    value={completedQty}
                    onChangeText={(t) => {
                        setCompletedQty(t)
                        saveValue(t, 'completedQty')
                    }}>
                </TextInput>
                <TextInput style={highlighted ? s().span1T : s().spanT}
                    value={completed$}
                    onChangeText={(t) => {
                        setCompleted$(t)
                        saveValue(t, 'completed$')
                    }}>
                </TextInput>
                <TextInput style={highlighted ? s().span1T : s().spanT}
                    value={remainingQty}
                    onChangeText={(t) => {
                        setRemainingQty(t)
                        saveValue(t, 'remainingQty')
                    }}>
                </TextInput> */}
                {/* <TextInput style={highlighted ? s().span1T : s().spanT}
                    value={qtyBudgetFcst}
                    onChangeText={(t) => {
                        setQtyBudgetFcst(t)
                        saveValue(t, 'qtyBudgetFcst')
                    }}>
                </TextInput>
                <TextInput style={highlighted ? s().span1T : s().spanT}
                    value={$BudgetFcst}
                    onChangeText={(t) => {
                        setLocalFocusedId(rowId + '-tAndM')$BudgetFcst(t)
                        saveValue(t, '$BudgetFcst')
                    }}>
                </TextInput> */}
                {!header ? <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <NumberInput style={highlighted ? s().span1T : s().spanT}
                        thousandSeparator
                        decimalSeparator="."
                        valueIsNumericString={true}
                        value={unitPrice?.formattedValue}
                        ref={e => { inputsRef.current[rowId + '-unitPrice'] = e }}
                        onFocus={() => { focusedId.current = rowId + '-unitPrice' }}
                        onValueChange={(t) => {
                            setUnitPrice(t)
                            setLocalFocusedId(rowId + '-unitPrice')
                            handleInputChange(t.floatValue, 'unitPrice')
                        }}
                    />
                </View> : <Text style={s().spanT}>{unitPrice?.formattedValue}</Text>}
                {!header ? <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <NumberInput style={highlighted ? s().span1T : s().spanT}
                        thousandSeparator
                        decimalSeparator="."
                        valueIsNumericString={true}
                        value={tAndM?.formattedValue}
                        ref={e => { inputsRef.current[rowId + '-tAndM'] = e }}
                        onFocus={() => { focusedId.current = rowId + '-tAndM' }}
                        onValueChange={(t) => {
                            setTAndM(t)
                            setLocalFocusedId(rowId + '-tAndM')
                            handleInputChange(t.floatValue, 'tAndM')
                        }}
                    />
                </View> : <Text style={s().spanT}>{tAndM?.formattedValue}</Text>}
                {!header ? <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <NumberInput style={highlighted ? s().span1T : s().spanT}
                        thousandSeparator
                        decimalSeparator="."
                        valueIsNumericString={true}
                        value={changeOrders?.formattedValue}
                        ref={e => { inputsRef.current[rowId + '-changeOrders'] = e }}
                        onFocus={() => { focusedId.current = rowId + '-changeOrders' }}
                        onValueChange={(t) => {
                            setChangeOrders(t)
                            setLocalFocusedId(rowId + '-changeOrders')
                            handleInputChange(t.floatValue, 'changeOrders')
                        }}
                    />
                </View> : <Text style={s().spanT}>{changeOrders?.formattedValue}</Text>}
                {!header ? <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <NumberInput style={highlighted ? s().span1T : s().spanT}
                        thousandSeparator
                        decimalSeparator="."
                        valueIsNumericString={true}
                        value={reductionOfScope?.formattedValue}
                        ref={e => { inputsRef.current[rowId + '-reductionOfScope'] = e }}
                        onFocus={() => { focusedId.current = rowId + '-reductionOfScope' }}
                        onValueChange={(t) => {
                            setReductionOfScope(t)
                            setLocalFocusedId(rowId + '-reductionOfScope')
                            handleInputChange(t.floatValue, 'reductionOfScope')
                        }}
                    />
                </View> : <Text style={s().spanT}>{reductionOfScope?.formattedValue}</Text>}
                <Text style={highlighted ? s().span1T : s().spanT}>{totalRevenue}</Text>
                <View style={{ width: 20 }}></View>
                {totalExpanded ? <View style={s().container}>
                    <Text style={highlighted ? s().span1T : s().spanT}></Text>
                    {unitsExpanded ? <View style={s().container}>
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={budgetQty?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-budgetQty'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-budgetQty' }}
                                onValueChange={(t) => {
                                    setBudgetQty(t)
                                    setLocalFocusedId(rowId + '-budgetQty')
                                    handleInputChange(t.floatValue, 'Quantity')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{budgetQty.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={totalLaborHours?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-totalLaborHours'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-totalLaborHours' }}
                                onValueChange={(t) => {
                                    setTotalLaborHours(t)
                                    setLocalFocusedId(rowId + '-totalLaborHours')
                                    handleInputChange(t.floatValue, 'totalLaborHours')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{totalLaborHours?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={totalEquipmentHours?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-totalEquipmentHours'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-totalEquipmentHours' }}
                                onValueChange={(t) => {
                                    setTotalEquipmentHours(t)
                                    setLocalFocusedId(rowId + '-totalEquipmentHours')
                                    handleInputChange(t.floatValue, 'totalEquipmentHours')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{totalEquipmentHours?.formattedValue}</Text>}
                    </View> : null}
                    <Text style={highlighted ? s().span1T : s().spanT}>{labor}</Text>
                    {laborExpanded ? <View style={s().container}>
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={regularTime?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-regularTime'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-regularTime' }}
                                onValueChange={(t) => {
                                    setRegularTime(t)
                                    setLocalFocusedId(rowId + '-regularTime')
                                    handleInputChange(t.floatValue, '51100')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{regularTime?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={overtime?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-overtime'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-overtime' }}
                                onValueChange={(t) => {
                                    setOvertime(t)
                                    setLocalFocusedId(rowId + '-overtime')
                                    handleInputChange(t.floatValue, '51200')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{overtime?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={burden?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-burden'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-burden' }}
                                onValueChange={(t) => {
                                    setBurden(t)
                                    setLocalFocusedId(rowId + '-burden')
                                    handleInputChange(t.floatValue, '51300')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{burden?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={byod?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-byod'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-byod' }}
                                onValueChange={(t) => {
                                    setByod(t)
                                    setLocalFocusedId(rowId + '-byod')
                                    handleInputChange(t.floatValue, '51400')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{byod?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={perDiem?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-perDiem'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-perDiem' }}
                                onValueChange={(t) => {
                                    setPerDiem(t)
                                    setLocalFocusedId(rowId + '-perDiem')
                                    handleInputChange(t.floatValue, '51500')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{perDiem?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={truckPay?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-truckPay'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-truckPay' }}
                                onValueChange={(t) => {
                                    setTruckPay(t)
                                    setLocalFocusedId(rowId + '-truckPay')
                                    handleInputChange(t.floatValue, '51600')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{truckPay?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={weldingRigPay?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-weldingRigPay'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-weldingRigPay' }}
                                onValueChange={(t) => {
                                    setWeldingRigPay(t)
                                    setLocalFocusedId(rowId + '-weldingRigPay')
                                    handleInputChange(t.floatValue, '51700')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{weldingRigPay?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={fieldBonus?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-fieldBonus'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-fieldBonus' }}
                                onValueChange={(t) => {
                                    setFieldBonus(t)
                                    setLocalFocusedId(rowId + '-fieldBonus')
                                    handleInputChange(t.floatValue, '51800')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{fieldBonus?.formattedValue}</Text>}
                    </View> : null}
                    <Text style={highlighted ? s().span1T : s().spanT}>{equipment}</Text>
                    {equipmentExpanded ? <View style={s().container}>
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={insideEquipmentRentals?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-insideEquipmentRentals'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-insideEquipmentRentals' }}
                                onValueChange={(t) => {
                                    setInsideEquipmentRentals(t)
                                    setLocalFocusedId(rowId + '-insideEquipmentRentals')
                                    handleInputChange(t.floatValue, '52100')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{insideEquipmentRentals?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={outsideEquipmentRentals?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-outsideEquipmentRentals'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-outsideEquipmentRentals' }}
                                onValueChange={(t) => {
                                    setOutsideEquipmentRentals(t)
                                    setLocalFocusedId(rowId + '-outsideEquipmentRentals')
                                    handleInputChange(t.floatValue, '52200')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{outsideEquipmentRentals?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={fuel?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-fuel'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-fuel' }}
                                onValueChange={(t) => {
                                    setFuel(t)
                                    setLocalFocusedId(rowId + '-fuel')
                                    handleInputChange(t.floatValue, '52300')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{fuel?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={repairs?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-repairs'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-repairs' }}
                                onValueChange={(t) => {
                                    setRepairs(t)
                                    setLocalFocusedId(rowId + '-repairs')
                                    handleInputChange(t.floatValue, '52400')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{repairs?.formattedValue}</Text>}
                    </View> : null}
                    <Text style={highlighted ? s().span1T : s().spanT}>{materialsTotal}</Text>
                    {materialsExpanded ? <View style={s().container}>
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={materials?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-materials'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-materials' }}
                                onValueChange={(t) => {
                                    setMaterials(t)
                                    setLocalFocusedId(rowId + '-materials')
                                    handleInputChange(t.floatValue, '53100')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{materials?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={mats?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-mats'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-mats' }}
                                onValueChange={(t) => {
                                    setMats(t)
                                    setLocalFocusedId(rowId + '-mats')
                                    handleInputChange(t.floatValue, '53200')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{mats?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={toolsSupplies?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-toolsSupplies'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-toolsSupplies' }}
                                onValueChange={(t) => {
                                    setToolsSupplies(t)
                                    setLocalFocusedId(rowId + '-toolsSupplies')
                                    handleInputChange(t.floatValue, '53300')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{toolsSupplies?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={skids?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-skids'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-skids' }}
                                onValueChange={(t) => {
                                    setSkids(t)
                                    setLocalFocusedId(rowId + '-skids')
                                    handleInputChange(t.floatValue, '53400')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{skids?.formattedValue}</Text>}
                    </View> : null}
                    <Text style={highlighted ? s().span1T : s().spanT}>{subs}</Text>
                    {subsExpanded ? <View style={s().container}>
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={internalSubs?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-internalSubs'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-internalSubs' }}
                                onValueChange={(t) => {
                                    setInternalSubs(t)
                                    setLocalFocusedId(rowId + '-internalSubs')
                                    handleInputChange(t.floatValue, '54100')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{internalSubs?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={externalSubs?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-externalSubs'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-externalSubs' }}
                                onValueChange={(t) => {
                                    setExternalSubs(t)
                                    setLocalFocusedId(rowId + '-externalSubs')
                                    handleInputChange(t.floatValue, '54200')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{externalSubs?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={haulingTransportation?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-haulingTransportation'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-haulingTransportation' }}
                                onValueChange={(t) => {
                                    setHaulingTransportation(t)
                                    setLocalFocusedId(rowId + '-haulingTransportation')
                                    handleInputChange(t.floatValue, '54300')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{haulingTransportation?.formattedValue}</Text>}
                    </View> : null}
                    <Text style={highlighted ? s().span1T : s().spanT}>{otherExpenses}</Text>
                    {otherExpanded ? <View style={s().container}>
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={personalMeals?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-personalMeals'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-personalMeals' }}
                                onValueChange={(t) => {
                                    setPersonalMeals(t)
                                    setLocalFocusedId(rowId + '-personalMeals')
                                    handleInputChange(t.floatValue, '55100')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{personalMeals?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={teamMealsEntertain?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-teamMealsEntertain'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-teamMealsEntertain' }}
                                onValueChange={(t) => {
                                    setTeamMealsEntertain(t)
                                    setLocalFocusedId(rowId + '-teamMealsEntertain')
                                    handleInputChange(t.floatValue, '55200')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{teamMealsEntertain?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={airfare?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-airfare'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-airfare' }}
                                onValueChange={(t) => {
                                    setAirfare(t)
                                    setLocalFocusedId(rowId + '-airfare')
                                    handleInputChange(t.floatValue, '55300')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{airfare?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={lodging?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-lodging'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-lodging' }}
                                onValueChange={(t) => {
                                    setLodging(t)
                                    setLocalFocusedId(rowId + '-lodging')
                                    handleInputChange(t.floatValue, '55400')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{lodging?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={otherTravelExpenses?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-otherTravelExpenses'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-otherTravelExpenses' }}
                                onValueChange={(t) => {
                                    setOtherTravelExpenses(t)
                                    setLocalFocusedId(rowId + '-otherTravelExpenses')
                                    handleInputChange(t.floatValue, '55900')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{otherTravelExpenses?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={fieldOfficeRent?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-fieldOfficeRent'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-fieldOfficeRent' }}
                                onValueChange={(t) => {
                                    setFieldOfficeRent(t)
                                    setLocalFocusedId(rowId + '-fieldOfficeRent')
                                    handleInputChange(t.floatValue, '56100')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{fieldOfficeRent?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={fieldOfficeUtility?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-fieldOfficeUtility'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-fieldOfficeUtility' }}
                                onValueChange={(t) => {
                                    setFieldOfficeUtility(t)
                                    setLocalFocusedId(rowId + '-fieldOfficeUtility')
                                    handleInputChange(t.floatValue, '56200')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{fieldOfficeUtility?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={fieldOfficeExpense?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-fieldOfficeExpense'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-fieldOfficeExpense' }}
                                onValueChange={(t) => {
                                    setFieldOfficeExpense(t)
                                    setLocalFocusedId(rowId + '-fieldOfficeExpense')
                                    handleInputChange(t.floatValue, '56300')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{fieldOfficeExpense?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={labFeesTesting?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-labFeesTesting'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-labFeesTesting' }}
                                onValueChange={(t) => {
                                    setLabFeesTesting(t)
                                    setLocalFocusedId(rowId + '-labFeesTesting')
                                    handleInputChange(t.floatValue, '56400')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{labFeesTesting?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={safetyPPE?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-safetyPPE'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-safetyPPE' }}
                                onValueChange={(t) => {
                                    setSafetyPPE(t)
                                    setLocalFocusedId(rowId + '-safetyPPE')
                                    handleInputChange(t.floatValue, '56500')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{safetyPPE?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={bondsInsurancePremiums?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-bondsInsurancePremiums'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-bondsInsurancePremiums' }}
                                onValueChange={(t) => {
                                    setBondsInsurancePremiums(t)
                                    setLocalFocusedId(rowId + '-bondsInsurancePremiums')
                                    handleInputChange(t.floatValue, '56600')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{bondsInsurancePremiums?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={permits?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-permits'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-permits' }}
                                onValueChange={(t) => {
                                    setPermits(t)
                                    setLocalFocusedId(rowId + '-permits')
                                    handleInputChange(t.floatValue, '56700')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{permits?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={insuranceClaims?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-insuranceClaims'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-insuranceClaims' }}
                                onValueChange={(t) => {
                                    setInsuranceClaims(t)
                                    setLocalFocusedId(rowId + '-insuranceClaims')
                                    handleInputChange(t.floatValue, '56800')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{insuranceClaims?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={taxes?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-taxes'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-taxes' }}
                                onValueChange={(t) => {
                                    setTaxes(t)
                                    setLocalFocusedId(rowId + '-taxes')
                                    handleInputChange(t.floatValue, '57100')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{taxes?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={accruedExpenses?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-accruedExpenses'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-accruedExpenses' }}
                                onValueChange={(t) => {
                                    setAccruedExpenses(t)
                                    setLocalFocusedId(rowId + '-accruedExpenses')
                                    handleInputChange(t.floatValue, '57200')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{accruedExpenses?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={warrantyReserve?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-warrantyReserve'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-warrantyReserve' }}
                                onValueChange={(t) => {
                                    setWarrantyReserve(t)
                                    setLocalFocusedId(rowId + '-warrantyReserve')
                                    handleInputChange(t.floatValue, '57300')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{warrantyReserve?.formattedValue}</Text>}
                        {!header ? <View style={{ position: 'relative' }}>
                            <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                            <NumberInput style={highlighted ? s().span1T : s().spanT}
                                thousandSeparator
                                decimalSeparator="."
                                valueIsNumericString={true}
                                value={misc?.formattedValue}
                                ref={e => { inputsRef.current[rowId + '-misc'] = e }}
                                onFocus={() => { focusedId.current = rowId + '-misc' }}
                                onValueChange={(t) => {
                                    setMisc(t)
                                    setLocalFocusedId(rowId + '-misc')
                                    handleInputChange(t.floatValue, '57900')
                                }}
                            />
                        </View> : <Text style={s().spanT}>{misc?.formattedValue}</Text>}
                    </View> : null}
                    <Text style={highlighted ? s().span1T : s().spanT}>{overhead}</Text>
                </View> : null}
                <Text style={highlighted ? s().span1T : s().spanT}>{totalCosts}</Text>
                <Text style={highlighted ? s().span1T : s().spanT}>{grossProfit}</Text>
                <Text style={highlighted ? s().span1T : s().spanT}>{gpPercent}</Text>
                {!header ? <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <TextInput style={[s(350).spanT, { height: 40 }]}
                        multiline
                        value={additionalNotes}
                        ref={e => { inputsRef.current[rowId + '-notes'] = e }}
                        onFocus={() => { focusedId.current = rowId + '-notes' }}
                        onChangeText={(t) => {
                            setAdditionalNotes(t)
                            handleInputChange(t, 'additionalNotes')
                            setLocalFocusedId(rowId + '-notes')
                        }}>
                    </TextInput>
                </View> : <Text style={s(350).spanT}>{additionalNotes}</Text>}
                {a.photo || header ? null : <Icon3 name={'MdClose'} size={20} color="#808080" onPress={deleteRow} style={{ display: 'flex', alignItems: 'center' }} />}
                {/* <TextInput style={highlighted ? s().span1T : s().spanT}
                    value={coBillings}
                    onChangeText={(t) => {
                        setCoBillings(t)
                    }}>
                </TextInput>
                <TextInput style={highlighted ? s().span1T : s().spanT}
                    value={totalCoBillingsAmount}
                    onChangeText={(t) => {
                        setTotalCoBillingsAmount(t)
                    }}>
                </TextInput>
                <TextInput style={highlighted ? s().span1T : s().spanT}
                    value={totalCoLeftToBill}
                    onChangeText={(t) => {
                        setTotalCoLeftToBill(t)
                    }}>
                </TextInput>
                <TextInput style={highlighted ? s().span1T : s().spanT}
                    value={reconciliationComments}
                    onChangeText={(t) => {
                        setReconciliationComments(t)
                    }}>
                </TextInput> */}
            </View>
        )
    }

    const importCOLogs = (file) => {
        // Logic to import CO Logs from an Excel file
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            // Process the imported data (json) as needed
        };
        reader.readAsArrayBuffer(file);
    };

    const fileSelectedHandler = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        uploadExcel(selectedFile);
        //uploadUserData(selectedFile);
    }

    const fileSelectedHandlerLong = (e) => {
        const selectedFile = e.target.files[0];
        setFileLong(selectedFile);
        uploadExcelLong(selectedFile);
        //uploadUserData(selectedFile);
    }

    const uploadExcelLong = (file = null) => {
        if (file) {
            const reader = new FileReader();

            reader.onload = (e) => {
            }
            reader.readAsArrayBuffer(file);
        }
    }

    const uploadExcel = (file = null) => {
        if (file) {

            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const parsedData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                // Assuming the first row contains column headers
                // You can customize this according to your Excel file structure

                const desiredColumns = ['CO No', 'Phase', 'Item Description', 'Status', 'Unit Price', 'T&M', 'Change Orders', 'Reduction of Scope', 'Total Revenue', 'budgetQty', 'totalLaborHours', 'totalEquipmentHours', '51100', '51200', '51300', '51400', '51500', '51600', '51700', '51800', '52100', '52200', '52300', '52400', '53100', '53200', '53300', '53400', '54100', '54200', '54300', '55100', '55200', '55300', '55400', '56100', '56200', '56300', '56400', '56500', '56600', '56700', '56800', '57100', '57200', '57300', '57900', 'overhead', 'Total Costs', 'Gross Margin', 'GP %', 'Additional Notes'];
                const columnIndexMap = {};
                const parsedColumns = parsedData[0];
                desiredColumns.forEach((col) => {
                    const index = parsedColumns.indexOf(col);
                    if (index !== -1) {
                        columnIndexMap[col] = index;
                    }
                });

                const extractedData = parsedData.slice(1).map((row) => {
                    const rowData = {};
                    desiredColumns.forEach((col) => {
                        rowData[col] = row[columnIndexMap[col]];
                    });
                    return rowData;
                });

                console.log('extractedData', extractedData);


                deleteCO({ id: selectedJob, forecastGuid: selectedVersion + '' }).then((data) => {
                    const rowsToSave = []
                    console.log('delete co', data)
                    extractedData.forEach((row, index) => {
                        // Save each field as a separate object, except for the grouped keys
                        const groupedKeys = [
                            'coNo',
                            'itemDescription',
                            'budgetQty',
                            'totalLaborHours',
                            'status',
                            'additionalNotes',
                            'phase'
                        ];

                        // Generate a unique rowId for this row
                        const rowId = row['CO No'] ? row['CO No'] + '' : 'row_' + index;

                        // First, save grouped fields as one object
                        const groupedObj = {
                            userId: userId || 'seth.bailey@strikeusa.com',
                            userName: userName || 'Seth Bailey',
                            tab: "CO Log",
                            rowId: rowId,
                            version: selectedVersion + '',
                            id: selectedJob,
                            lockedVersion: lockedVersion,
                            fieldName: 'coNo',
                            rowLabel: row['CO No'] || '',
                            costCode: row['Phase'] || '',
                            description: row['Item Description'] || '',
                            quantity: row['budgetQty'] || '',
                            hours: row['totalLaborHours'] || '',
                            status: row['Status'] || '',
                            notes: row['Additional Notes'] || ''
                        };
                        rowsToSave.push(groupedObj);
                        // Map Excel column names to database field names for special cases
                        const fieldMap = {
                            'Unit Price': 'unitPrice',
                            'T&M': 'tAndM',
                            'Change Orders': 'changeOrders',
                            'Reduction of Scope': 'reductionOfScope'
                        };

                        // Add special fields if present in the row
                        Object.keys(fieldMap).forEach((excelKey) => {
                            if (row[excelKey] !== undefined) {
                                rowsToSave.push({
                                    userId: userId || 'seth.bailey@strikeusa.com',
                                    userName: userName || 'Seth Bailey',
                                    tab: "CO Log",
                                    rowId: rowId,
                                    version: selectedVersion + '',
                                    id: selectedJob,
                                    lockedVersion: lockedVersion,
                                    fieldName: fieldMap[excelKey],
                                    value: row[excelKey] != null ? row[excelKey] + '' : '',
                                    valueAmount: isNaN(pNum(row[excelKey])) ? '' : pNum(row[excelKey]),
                                    costCode: row['Phase'] || '',
                                    costType: isNaN(pNum(fieldMap[excelKey])) ? '' : pNum(fieldMap[excelKey]),
                                    rowLabel: row['CO No'] || '',
                                    description: row['Item Description'] || '',
                                    quantity: row['budgetQty'] || '',
                                    hours: row['totalLaborHours'] || '',
                                    status: row['Status'] || '',
                                    notes: row['Additional Notes'] || ''
                                });
                            }
                        });
                        // Now, for all other fields, save as separate objects
                        Object.keys(row).forEach((key) => {
                            if (!groupedKeys.includes(key)) {
                                rowsToSave.push({
                                    userId: userId || 'seth.bailey@strikeusa.com',
                                    userName: userName || 'Seth Bailey',
                                    tab: "CO Log",
                                    rowId: rowId,
                                    version: selectedVersion + '',
                                    id: selectedJob,
                                    lockedVersion: lockedVersion,
                                    fieldName: key,
                                    value: row[key] != null ? row[key] + '' : '',
                                    valueAmount: isNaN(pNum(row[key])) ? '' : pNum(row[key]),
                                    costCode: row['Phase'] || '',
                                    costType: isNaN(pNum(key)) ? '' : pNum(key),
                                    rowLabel: row['CO No'] || '',
                                    description: row['Item Description'] || '',
                                    quantity: row['budgetQty'] || '',
                                    hours: row['totalLaborHours'] || '',
                                    status: row['Status'] || '',
                                    notes: row['Additional Notes'] || ''
                                });
                            }
                        });
                    });

                    // Save all rows
                    updateUserDataArray(rowsToSave);
                    setCORows(rowsToSave);
                })
            };
            reader.readAsArrayBuffer(file);
        }
    }

    /**
     * Exports the CO Log data to an Excel file with Upload and Headers sheets (new format).
     * @param {Array} logs - Array of CO Log objects.
     * @param {string} filename - Name of the file to download.
     */
    const exportCOLogsToExcel = async (logs, filename = null) => {
        const coRecords = jobUserData.filter(row => 
            (row.Forecast_Tab === 'CO Log' || row.Forecast_Tab === 'CO LOG') &&
            row.BU_ID == selectedJob &&
            row.Version_GUID == selectedVersion.toString()
        );
        
        filename = `colog_${selectedJob}.xlsx`;

        setIsExporting(true);
        
        try {
            // Find the highest existing Row_Label number to avoid conflicts
            const existingNumbers = logs
                .map(log => parseFloat(log.Row_Label || log.rowLabel || '0'))
                .filter(num => !isNaN(num));
            const maxNumber = existingNumbers.length > 0 ? Math.max(...existingNumbers) : 0;
            let autoIncrementId = Math.floor(maxNumber) + 1000; // Start well above existing numbers

            // Create a map to assign consistent coIds for logs without Row_Label
            const logToCoIdMap = new Map();
            logs.forEach((log, index) => {
                let coId = log.Row_Label || log.rowLabel || '';
                
                // Assign a unique number if Row_Label is missing
                if (!coId) {
                    coId = autoIncrementId.toString();
                    autoIncrementId++;
                }
                
                logToCoIdMap.set(index, coId);
            });

            // Group records by Row_Label to create header rows
            const coIdMap = new Map();
            coRecords.forEach(row => {
                const coId = row.rowLabel || row.Row_Label || '';
                if (coId && !coIdMap.has(coId)) {
                    // Store first occurrence of each CO ID with its basic info
                    coIdMap.set(coId, {
                        id: coId,
                        description: row.description || row.Description || '',
                        resourceCode: row.resourceCode || row.Resource_Code || '',
                        status: row.status || row.Status || '',
                        notes: row.notes || row.Notes || '',
                        po: row.po || row.PO_Number || '',
                        projectStart: row.projectStart || row.Project_Start || '',
                        projectEnd: row.projectEnd || row.Project_End || '',
                        phaseStart: row.phaseStart || row.Phase_Start || '',
                        active: row.active || row.Active || false,
                        equipmentTier: row.equipmentTier || row.Equipment_Tier || false
                    });
                }
            });

            // Build header rows from grouped data
            const headerRowsMap = new Map();
            logs.forEach((log, index) => {
                const coId = logToCoIdMap.get(index);
                
                if (coId && !headerRowsMap.has(coId)) {
                    // Determine Revenue Type based on which revenue fields have values
                    let revenueType = '';
                    if (log.unitPrice) revenueType = 'Unit Price';
                    else if (log.tAndM) revenueType = 'T&M';
                    else if (log.changeOrders) revenueType = 'Change Order';
                    else if (log.reductionOfScope) revenueType = 'Reduction of Scope';
                    
                    headerRowsMap.set(coId, {
                        'No.': coId,
                        'Type': '',  // Empty - no data currently
                        'Revenue Type': revenueType,
                        'Description': log.Description || log.description || '',
                        'Status': log.Status || log.status || '',
                        'Initiated': '',  // Empty - no data currently
                        'Submitted': '',  // Empty - no data currently
                        'Signed': '',  // Empty - no data currently
                        'Revenue': '',  // Empty - no data currently
                        'Cumulative Amount to': '',  // Empty - no data currently
                        'Extension': '',  // Empty - no data currently
                        'Task': false,  // Default to false
                        'Critical Path': false,  // Default to false
                        'GM%': '',  // Empty - no data currently
                        'Notes': log.Notes || log.notes || ''
                    });
                }
            });
            const headersData = Array.from(headerRowsMap.values());

            const uploadData = coRecords.flatMap(row => {
                const fieldName = row.Forecast_Field_Name || '';
                const coId = row.rowLabel || row.Row_Label || '';
                const status = row.status || row.Status || '';
                const costCode = row.costCode || row.Cost_Code || '';
                const resourceCode = row.resourceCode || row.Resource_Code || '';
                const value = row.Value_Amount ? pNum(row.Value_Amount) : 0;
                
                // Revenue fields mapping (tandM, changeOrder, reductionOfScope, unitPrice)
                const revenueFields = ['tAndM', 'changeOrders', 'reductionOfScope', 'unitPrice'];
                if (revenueFields.some(rf => fieldName.toLowerCase().includes(rf.toLowerCase()))) {
                    return {
                        'CO ID': coId,
                        'Status': status,
                        'Cost Code': costCode,
                        'Cost Type': '41000',
                        'Dollars': value,
                        'Hours': 0,
                        'Resource Code': resourceCode,
                        'Quantity': 0
                    };
                }
                
                // budgetQty mapping
                if (fieldName === 'budgetQty' || fieldName === 'Quantity') {
                    return {
                        'CO ID': coId,
                        'Status': status,
                        'Cost Code': costCode,
                        'Cost Type': '51100',
                        'Dollars': 0,
                        'Hours': 0,
                        'Resource Code': resourceCode,
                        'Quantity': value
                    };
                }
                
                // totalLaborHours mapping
                if (fieldName === 'totalLaborHours' || fieldName === 'Hours') {
                    return {
                        'CO ID': coId,
                        'Status': status,
                        'Cost Code': costCode,
                        'Cost Type': '51100',
                        'Dollars': 0,
                        'Hours': value,
                        'Resource Code': resourceCode,
                        'Quantity': 0
                    };
                }
                
                // totalEquipmentHours mapping
                if (fieldName === 'totalEquipmentHours') {
                    return {
                        'CO ID': coId,
                        'Status': status,
                        'Cost Code': costCode,
                        'Cost Type': '52100',
                        'Dollars': 0,
                        'Hours': value,
                        'Resource Code': resourceCode,
                        'Quantity': 0
                    };
                }
                
                // Cost type fields starting with 5 (51100, 51200, etc.)
                if (fieldName.startsWith('5') && fieldName.length === 5) {
                    return {
                        'CO ID': coId,
                        'Status': status,
                        'Cost Code': costCode,
                        'Cost Type': fieldName,
                        'Dollars': value,
                        'Hours': 0,
                        'Resource Code': resourceCode,
                        'Quantity': 0
                    };
                }

            // Return empty array to skip items that don't match any condition
            return [];
            });

            // Sort both datasets by CO ID
            const sortByCoId = (a, b) => {
                const aId = parseFloat(a['No.'] || a['CO ID']) || 0;
                const bId = parseFloat(b['No.'] || b['CO ID']) || 0;
                return aId - bId;
            };

            headersData.sort(sortByCoId);
            uploadData.sort(sortByCoId);

            console.log('Prepared Upload Data:', uploadData);
            const response = await fetch('https://forecastingtestpythonservice.azurewebsites.net/api/download_co_template', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    coRows: uploadData.length > 0 ? uploadData : [],
                    combinations: headersData.length > 0 ? headersData : [],
                    jobId: selectedJob,
                    customerViewRows: headersData.length > 0 ? headersData : [],
                    jobData: selectedJobData,
                    logs: logs && logs.length > 0 ? logs : []
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);

            console.log('CO Log Excel file with Upload and Headers sheets downloaded successfully');
        } catch (error) {
            console.error('Error downloading CO Log Excel file:', error);
            alert('Failed to download CO Log Excel file. Please try again.');
        } finally {
            setIsExporting(false);
        }
    };

    const verifyStatusForChangeOrder = async (specificCoId = null) => {
        console.log('Starting status verification for CO ID:', specificCoId);
        
        try {
            // Get active and pending jobs
            const activeJobs = jobs.filter(job => job.Job_Status === 'A' || job.Job_Status === 'P');
            const jobIds = activeJobs.map(job => job.BU_ID);

            if (jobIds.length === 0) {
                alert('No active or pending jobs found');
                return;
            }

            console.log(`Fetching data for ${jobIds.length} active/pending jobs for verification...`);
            
            // Fetch team user data for all active/pending jobs
            const teamData = await loadTeamUserDataMain({
                ids: jobIds,
                forecastGuid: selectedVersion
            });

            if (!teamData?.data || teamData.data.length === 0) {
                alert('No data found for active/pending jobs');
                return;
            }

            // Filter for CO Log and Change Order tab data
            let coLogRecords = teamData.data.filter(record => 
                record.Forecast_Tab === 'CO Log' || record.Forecast_Tab === 'CO LOG'
            );

            let changeOrderRecords = teamData.data.filter(record => 
                record.Forecast_Tab === 'Change Order'
            );

            // If specific CO ID provided, filter for that CO
            if (specificCoId) {
                coLogRecords = coLogRecords.filter(record => 
                    record.Row_Label === specificCoId || record.Row_Label === String(specificCoId)
                );
                changeOrderRecords = changeOrderRecords.filter(record => 
                    record.Row_Label === specificCoId || record.Row_Label === String(specificCoId)
                );
                
                if (coLogRecords.length === 0 && changeOrderRecords.length === 0) {
                    alert(`No records found for CO ID: ${specificCoId}`);
                    return;
                }
            }

            console.log(`Verifying ${coLogRecords.length} CO Log records against ${changeOrderRecords.length} Change Order records...`);

            // Build maps for both tabs grouped by Job ID and Row Label
            const coLogMap = {}; // jobId -> rowLabel -> { status, records[] }
            const changeOrderMap = {}; // jobId -> rowLabel -> { status, records[] }

            // Process CO Log records
            coLogRecords.forEach(row => {
                const rowLabel = row.Row_Label || '';
                const status = row.Status || '';
                const jobId = row.BU_ID || '';
                
                if (rowLabel && jobId) {
                    if (!coLogMap[jobId]) coLogMap[jobId] = {};
                    if (!coLogMap[jobId][rowLabel]) {
                        coLogMap[jobId][rowLabel] = { 
                            status: status, 
                            records: [],
                            statuses: new Set()
                        };
                    }
                    
                    coLogMap[jobId][rowLabel].records.push({
                        fieldName: row.Forecast_Field_Name,
                        costCode: row.Cost_Code,
                        resourceCode: row.Resource_Code,
                        status: status,
                        value: row.Value_Amount
                    });
                    coLogMap[jobId][rowLabel].statuses.add(status);
                    
                    // Prioritize "Approved" status
                    if (status === 'Approved') {
                        coLogMap[jobId][rowLabel].status = status;
                    }
                }
            });

            // Process Change Order records
            changeOrderRecords.forEach(row => {
                const rowLabel = row.Row_Label || '';
                const status = row.Status || '';
                const jobId = row.BU_ID || '';
                
                if (rowLabel && jobId) {
                    if (!changeOrderMap[jobId]) changeOrderMap[jobId] = {};
                    if (!changeOrderMap[jobId][rowLabel]) {
                        changeOrderMap[jobId][rowLabel] = { 
                            status: status, 
                            records: [],
                            statuses: new Set()
                        };
                    }
                    
                    changeOrderMap[jobId][rowLabel].records.push({
                        fieldName: row.Forecast_Field_Name,
                        costCode: row.Cost_Code,
                        resourceCode: row.Resource_Code,
                        status: status,
                        value: row.Value_Amount
                    });
                    changeOrderMap[jobId][rowLabel].statuses.add(status);
                    
                    // Prioritize "Approved" status
                    if (status === 'Approved') {
                        changeOrderMap[jobId][rowLabel].status = status;
                    }
                }
            });

            // Compare the two maps
            const verificationResults = [];
            const mismatches = [];
            const missingInChangeOrder = [];
            const extraInChangeOrder = [];

            // Check all CO Log entries
            Object.keys(coLogMap).forEach(jobId => {
                Object.keys(coLogMap[jobId]).forEach(rowLabel => {
                    const coLogData = coLogMap[jobId][rowLabel];
                    const changeOrderData = changeOrderMap[jobId]?.[rowLabel];
                    
                    if (!changeOrderData) {
                        // CO exists in CO Log but not in Change Order
                        missingInChangeOrder.push({
                            jobId: jobId,
                            coId: rowLabel,
                            coLogStatus: coLogData.status,
                            coLogStatuses: Array.from(coLogData.statuses),
                            coLogRecordCount: coLogData.records.length
                        });
                    } else {
                        // CO exists in both - compare statuses
                        const statusMatch = coLogData.status === changeOrderData.status;
                        
                        const result = {
                            jobId: jobId,
                            coId: rowLabel,
                            coLogStatus: coLogData.status,
                            changeOrderStatus: changeOrderData.status,
                            statusMatch: statusMatch,
                            coLogStatuses: Array.from(coLogData.statuses),
                            changeOrderStatuses: Array.from(changeOrderData.statuses),
                            coLogRecordCount: coLogData.records.length,
                            changeOrderRecordCount: changeOrderData.records.length
                        };
                        
                        verificationResults.push(result);
                        
                        if (!statusMatch) {
                            mismatches.push(result);
                        }
                    }
                });
            });

            // Check for entries in Change Order that don't exist in CO Log
            Object.keys(changeOrderMap).forEach(jobId => {
                Object.keys(changeOrderMap[jobId]).forEach(rowLabel => {
                    if (!coLogMap[jobId]?.[rowLabel]) {
                        extraInChangeOrder.push({
                            jobId: jobId,
                            coId: rowLabel,
                            changeOrderStatus: changeOrderMap[jobId][rowLabel].status,
                            changeOrderStatuses: Array.from(changeOrderMap[jobId][rowLabel].statuses),
                            changeOrderRecordCount: changeOrderMap[jobId][rowLabel].records.length
                        });
                    }
                });
            });

            // Display results
            console.log('=== VERIFICATION RESULTS ===');
            console.log(`Jobs checked: ${jobIds.length}`);
            console.log(`CO Log entries: ${coLogRecords.length}`);
            console.log(`Change Order entries: ${changeOrderRecords.length}`);
            console.log(`Matching COs: ${verificationResults.length}`);
            console.log(`Status matches: ${verificationResults.filter(r => r.statusMatch).length}`);
            console.log(`Status mismatches: ${mismatches.length}`);
            console.log(`Missing in Change Order: ${missingInChangeOrder.length}`);
            console.log(`Extra in Change Order: ${extraInChangeOrder.length}`);
            
            if (mismatches.length > 0) {
                console.log('\n=== STATUS MISMATCHES ===');
                mismatches.forEach(mismatch => {
                    console.log(`\nJob: ${mismatch.jobId}, CO ID: ${mismatch.coId}`);
                    console.log(`  CO Log Status: ${mismatch.coLogStatus} (from: ${mismatch.coLogStatuses.join(', ')})`);
                    console.log(`  Change Order Status: ${mismatch.changeOrderStatus} (from: ${mismatch.changeOrderStatuses.join(', ')})`);
                    console.log(`  Records: CO Log=${mismatch.coLogRecordCount}, Change Order=${mismatch.changeOrderRecordCount}`);
                });
            }

            if (missingInChangeOrder.length > 0) {
                console.log('\n=== MISSING IN CHANGE ORDER ===');
                missingInChangeOrder.forEach(missing => {
                    console.log(`\nJob: ${missing.jobId}, CO ID: ${missing.coId}`);
                    console.log(`  CO Log Status: ${missing.coLogStatus} (from: ${missing.coLogStatuses.join(', ')})`);
                    console.log(`  Records in CO Log: ${missing.coLogRecordCount}`);
                });
            }

            if (extraInChangeOrder.length > 0) {
                console.log('\n=== EXTRA IN CHANGE ORDER (NOT IN CO LOG) ===');
                extraInChangeOrder.forEach(extra => {
                    console.log(`\nJob: ${extra.jobId}, CO ID: ${extra.coId}`);
                    console.log(`  Change Order Status: ${extra.changeOrderStatus} (from: ${extra.changeOrderStatuses.join(', ')})`);
                    console.log(`  Records in Change Order: ${extra.changeOrderRecordCount}`);
                });
            }

            // Create summary message
            const totalIssues = mismatches.length + missingInChangeOrder.length + extraInChangeOrder.length;
            
            if (totalIssues > 0) {
                const summaryMsg = `Verification Complete!\n\n` +
                    `Jobs Checked: ${jobIds.length}\n` +
                    `Matching COs: ${verificationResults.length}\n\n` +
                    `Issues Found: ${totalIssues}\n` +
                    `  • Status Mismatches: ${mismatches.length}\n` +
                    `  • Missing in Change Order: ${missingInChangeOrder.length}\n` +
                    `  • Extra in Change Order: ${extraInChangeOrder.length}\n\n` +
                    (specificCoId && verificationResults.length > 0 ? 
                        `CO ID ${specificCoId}:\n` +
                        `  CO Log: ${verificationResults[0]?.coLogStatus}\n` +
                        `  Change Order: ${verificationResults[0]?.changeOrderStatus || 'NOT FOUND'}\n` +
                        `  Status: ${verificationResults[0]?.statusMatch ? '✓ MATCH' : '✗ MISMATCH'}`
                        :
                        `Check console for detailed report.`
                    );
                
                alert(summaryMsg);
            } else {
                const successMsg = specificCoId ?
                    `✓ Verification Passed!\n\nCO ID ${specificCoId}:\n` +
                    `  CO Log Status: ${verificationResults[0]?.coLogStatus}\n` +
                    `  Change Order Status: ${verificationResults[0]?.changeOrderStatus}\n` +
                    `  All statuses match!`
                    :
                    `✓ All ${verificationResults.length} matching COs have consistent statuses!\n\n` +
                    `No issues found between CO Log and Change Order tabs.`;
                
                alert(successMsg);
            }

            return {
                results: verificationResults,
                mismatches: mismatches,
                missingInChangeOrder: missingInChangeOrder,
                extraInChangeOrder: extraInChangeOrder
            };

        } catch (error) {
            console.error('Error verifying CO status:', error);
            alert('Failed to verify CO status: ' + error.message);
            return null;
        }
    };

    const bulkCopyActiveJobs = async () => {
        // if (!confirm('This will copy all CO Log/CO LOG data from active and pending jobs to Change Order tab. Continue?')) {
        //     return;
        // }

        setIsCopying(true);
        try {
            // Get closed jobs
            const activeJobs = jobs.filter(job => job.Job_Status === 'C');
            const jobIds = activeJobs.map(job => job.BU_ID);
            console.log('jobs', jobIds)

            if (jobIds.length === 0) {
                alert('No closed jobs found');
                return;
            }

            console.log(`Fetching data for ${jobIds.length} active/pending jobs...`);
            
            // Fetch team user data for all active/pending jobs
            const teamData = await loadTeamUserDataMain({
                ids: jobIds,
                forecastGuid: selectedVersion
            });

            if (!teamData?.data || teamData.data.length === 0) {
                alert('No data found for active/pending jobs');
                return;
            }

            // Filter for CO Log and CO LOG tab data
            const coLogRecords = teamData.data.filter(record => 
                record.Forecast_Tab === 'CO Log' || record.Forecast_Tab === 'CO LOG'
            );
            
            if (coLogRecords.length === 0) {
                alert('No CO Log data found to copy');
                return;
            }

            console.log(`Processing ${coLogRecords.length} CO Log records from ${jobIds.length} jobs to copy to Change Order tab...`);

            // Build a status map: for each Row_Label, prioritize "Approved" status
            // This ensures all rows with the same Row_Label get the same status
            const statusMap = {};
            coLogRecords.forEach(row => {
                const rowLabel = row.Row_Label || '';
                const status = row.Status || '';
                
                if (rowLabel && status) {
                    // If we haven't seen this rowLabel yet, or if the current status is "Approved", use it
                    // This prioritizes "Approved" over other statuses like "Not Submitted"
                    if (!statusMap[rowLabel] || status === 'Approved') {
                        statusMap[rowLabel] = status;
                    }
                }
            });
            
            console.log('Status map:', statusMap);

            // Apply same flatMap transformation logic as export
            const transformedRecords = coLogRecords.flatMap(row => {
                const fieldName = row.Forecast_Field_Name || '';
                const rowLabel = row.Row_Label || '';
                const costCode = row.Cost_Code || '';
                const resourceCode = row.Resource_Code || '';
                // Always use the status from the map if available, otherwise use the row's status
                const status = row.Status || statusMap[rowLabel] || '';
                const value = row.Value_Amount ? pNum(row.Value_Amount) : 0;
                
                // Revenue fields mapping (tandM, changeOrder, reductionOfScope, unitPrice)
                const revenueFields = ['tAndM', 'changeOrders', 'reductionOfScope', 'unitPrice'];
                if (revenueFields.some(rf => fieldName.toLowerCase().includes(rf.toLowerCase()))) {
                    return {
                        fieldName: fieldName,
                        rowLabel: rowLabel,
                        costCode: costCode,
                        costType: '41000',
                        dollars: value,
                        hours: 0,
                        quantity: 0,
                        resourceCode: resourceCode,
                        status: status,
                        id: row.BU_ID,
                        rowId: row.Forecast_Row_ID || ''
                    };
                }
                
                // budgetQty mapping
                if (fieldName === 'budgetQty' || fieldName === 'Quantity') {
                    return {
                        fieldName: fieldName,
                        rowLabel: rowLabel,
                        costCode: costCode,
                        costType: '51100',
                        dollars: 0,
                        hours: 0,
                        quantity: value,
                        resourceCode: resourceCode,
                        status: status,
                        id: row.BU_ID,
                        rowId: row.Forecast_Row_ID || ''
                    };
                }
                
                // totalLaborHours mapping
                if (fieldName === 'totalLaborHours' || fieldName === 'Hours') {
                    return {
                        fieldName: fieldName,
                        rowLabel: rowLabel,
                        costCode: costCode,
                        costType: '51100',
                        dollars: 0,
                        hours: value,
                        quantity: 0,
                        resourceCode: resourceCode,
                        status: status,
                        id: row.BU_ID,
                        rowId: row.Forecast_Row_ID || ''
                    };
                }
                
                // totalEquipmentHours mapping
                if (fieldName === 'totalEquipmentHours') {
                    return {
                        fieldName: fieldName,
                        rowLabel: rowLabel,
                        costCode: costCode,
                        costType: '52100',
                        dollars: 0,
                        hours: value,
                        quantity: 0,
                        resourceCode: resourceCode,
                        status: status,
                        id: row.BU_ID,
                        rowId: row.Forecast_Row_ID || ''

                    };
                }
                
                // Cost type fields starting with 5 (51100, 51200, etc.)
                if (fieldName.startsWith('5') && fieldName.length === 5) {
                    return {
                        fieldName: fieldName,
                        rowLabel: rowLabel,
                        costCode: costCode,
                        costType: fieldName,
                        dollars: value,
                        hours: 0,
                        quantity: 0,
                        resourceCode: resourceCode,
                        status: status,
                        id: row.BU_ID,
                        rowId: row.Forecast_Row_ID || ''
                    };
                }

                // Return empty array to skip items that don't match any condition
                return [];
            });

            if (transformedRecords.length === 0) {
                alert('No valid records found after transformation');
                return;
            }

            // Map to updateUserDataArray format with only necessary fields
            const insertRecords = transformedRecords.map(record => ({
                id: record.id,
                userId: userId,
                userName: userName,
                fieldName: record.fieldName,
                version: selectedVersion.toString(),
                tab: 'Change Order',
                rowLabel: record.rowLabel || '',
                rowId: record.rowId || '',
                valueAmount: Number(record.dollars) || 0,
                hours: Number(record.hours) || 0,
                quantity: Number(record.quantity) || 0,
                costType: record.costType,
                costCode: record.costCode,
                resourceCode: record.resourceCode,
                status: record.status,
                insertRow: 1
            }));

            console.log(`Transformed ${insertRecords.length} records for insertion...`);
            console.log('first 5 records:', coLogRecords);

            // Batch insert in chunks of 500
            const chunkSize = 500;
            let successCount = 0;
            let errorCount = 0;

            for (let i = 0; i < insertRecords.length; i += chunkSize) {
                const chunk = insertRecords.slice(i, i + chunkSize);
                console.log(`Inserting chunk ${Math.floor(i / chunkSize) + 1}/${Math.ceil(insertRecords.length / chunkSize)}...`);

                const result = await updateUserDataArray(chunk);
                
                if (result && result.data) {
                    successCount += chunk.length;
                } else {
                    errorCount += chunk.length;
                }
            }

            console.log(`CO Log to Change Order copy complete: ${successCount} records inserted, ${errorCount} errors`);
            alert(`Copy complete!\n${successCount} records copied from CO Log to Change Order tab${errorCount > 0 ? `\n${errorCount} errors` : ''}`);

        } catch (error) {
            console.error('Error copying CO Log to Change Order:', error);
            alert('Failed to copy CO Log data: ' + error.message);
        } finally {
            setIsCopying(false);
        }
    };

    const calculateTotals = (userData = null) => {
        let addersToBudgetQty = 0
        let budgetQty = 0
        let unitPrice = 0
        let tAndM = 0
        let changeOrders = 0
        let reductionOfScope = 0
        let totalRevenue = 0
        let totalRegularTime = 0
        let totalOvertime = 0
        let totalBurden = 0
        let totalByod = 0
        let totalPerDiem = 0
        let totalTruckPay = 0
        let totalWeldingRigPay = 0
        let totalFieldBonus = 0
        let totalLabor = 0
        let totalTotalLaborHours = 0
        let totalTotalEquipmentHours = 0
        let totalInsideEquipmentRentals = 0
        let totalOutsideEquipmentRentals = 0
        let totalFuel = 0
        let totalRepairs = 0
        let totalEquipment = 0
        let totalMaterials = 0
        let totalMats = 0
        let totalToolsSupplies = 0
        let totalSkids = 0
        let totalMaterialsTotal = 0
        let totalInternalSubs = 0
        let totalExternalSubs = 0
        let totalHaulingTransportation = 0
        let totalSubs = 0
        let totalPersonalMeals = 0
        let totalTeamMealsEntertain = 0
        let totalAirfare = 0
        let totalLodging = 0
        let totalFieldOfficeRent = 0
        let totalFieldOfficeUtility = 0
        let totalFieldOfficeExpense = 0
        let totalLabFeesTesting = 0
        let totalSafetyPPE = 0
        let totalBondsInsurancePremiums = 0
        let totalPermits = 0
        let totalInsuranceClaims = 0
        let totalTaxes = 0
        let totalAccruedExpenses = 0
        let totalWarrantyReserve = 0
        let totalMisc = 0
        let totalOtherTravelExpenses = 0
        let totalOtherExpenses = 0
        let totalOverhead = 0

        let addersToBudgetQtyPending = 0
        let budgetQtyPending = 0
        let unitPricePending = 0
        let tAndMPending = 0
        let changeOrdersPending = 0
        let reductionOfScopePending = 0
        let totalRevenuePending = 0
        let totalRegularTimePending = 0
        let totalOvertimePending = 0
        let totalBurdenPending = 0
        let totalByodPending = 0
        let totalPerDiemPending = 0
        let totalTruckPayPending = 0
        let totalWeldingRigPayPending = 0
        let totalFieldBonusPending = 0
        let totalLaborPending = 0
        let totalTotalLaborHoursPending = 0
        let totalTotalEquipmentHoursPending = 0
        let totalInsideEquipmentRentalsPending = 0
        let totalOutsideEquipmentRentalsPending = 0
        let totalFuelPending = 0
        let totalRepairsPending = 0
        let totalEquipmentPending = 0
        let totalMaterialsPending = 0
        let totalMatsPending = 0
        let totalToolsSuppliesPending = 0
        let totalSkidsPending = 0
        let totalMaterialsTotalPending = 0
        let totalInternalSubsPending = 0
        let totalExternalSubsPending = 0
        let totalHaulingTransportationPending = 0
        let totalSubsPending = 0
        let totalPersonalMealsPending = 0
        let totalTeamMealsEntertainPending = 0
        let totalAirfarePending = 0
        let totalLodgingPending = 0
        let totalFieldOfficeRentPending = 0
        let totalFieldOfficeUtilityPending = 0
        let totalFieldOfficeExpensePending = 0
        let totalLabFeesTestingPending = 0
        let totalSafetyPPEPending = 0
        let totalBondsInsurancePremiumsPending = 0
        let totalPermitsPending = 0
        let totalInsuranceClaimsPending = 0
        let totalTaxesPending = 0
        let totalAccruedExpensesPending = 0
        let totalWarrantyReservePending = 0
        let totalMiscPending = 0
        let totalOtherTravelExpensesPending = 0
        let totalOtherExpensesPending = 0
        let totalOverheadPending = 0

        let addersToBudgetQtyApproved = 0
        let budgetQtyApproved = 0
        let unitPriceApproved = 0
        let tAndMApproved = 0
        let changeOrdersApproved = 0
        let reductionOfScopeApproved = 0
        let totalRevenueApproved = 0
        let totalRegularTimeApproved = 0
        let totalOvertimeApproved = 0
        let totalBurdenApproved = 0
        let totalByodApproved = 0
        let totalPerDiemApproved = 0
        let totalTruckPayApproved = 0
        let totalWeldingRigPayApproved = 0
        let totalFieldBonusApproved = 0
        let totalLaborApproved = 0
        let totalTotalLaborHoursApproved = 0
        let totalTotalEquipmentHoursApproved = 0
        let totalInsideEquipmentRentalsApproved = 0
        let totalOutsideEquipmentRentalsApproved = 0
        let totalFuelApproved = 0
        let totalRepairsApproved = 0
        let totalEquipmentApproved = 0
        let totalMaterialsApproved = 0
        let totalMatsApproved = 0
        let totalToolsSuppliesApproved = 0
        let totalSkidsApproved = 0
        let totalMaterialsTotalApproved = 0
        let totalInternalSubsApproved = 0
        let totalExternalSubsApproved = 0
        let totalHaulingTransportationApproved = 0
        let totalSubsApproved = 0
        let totalPersonalMealsApproved = 0
        let totalTeamMealsEntertainApproved = 0
        let totalAirfareApproved = 0
        let totalLodgingApproved = 0
        let totalFieldOfficeRentApproved = 0
        let totalFieldOfficeUtilityApproved = 0
        let totalFieldOfficeExpenseApproved = 0
        let totalLabFeesTestingApproved = 0
        let totalSafetyPPEApproved = 0
        let totalBondsInsurancePremiumsApproved = 0
        let totalPermitsApproved = 0
        let totalInsuranceClaimsApproved = 0
        let totalTaxesApproved = 0
        let totalAccruedExpensesApproved = 0
        let totalWarrantyReserveApproved = 0
        let totalMiscApproved = 0
        let totalOtherTravelExpensesApproved = 0
        let totalOtherExpensesApproved = 0
        let totalOverheadApproved = 0

        const userD = {}
        coLogs.forEach((log) => {
            userD[log.id] = log
        })
        //console.log('userD', userD, userData)


        Object.values(userData ? userData : userD).forEach((row) => {
            budgetQty = budgetQty + (isNaN(pNum(row.budgetQty)) ? 0 : pNum(row.budgetQty))
            addersToBudgetQty = addersToBudgetQty + (isNaN(pNum(row.addersToBudgetQty)) ? 0 : pNum(row.addersToBudgetQty))
            unitPrice = unitPrice + pNum(row.unitPrice)
            tAndM = tAndM + (isNaN(pNum(row.tAndM)) ? 0 : pNum(row.tAndM))
            changeOrders = changeOrders + (isNaN(pNum(row.changeOrders)) ? 0 : pNum(row.changeOrders))
            reductionOfScope = reductionOfScope + (isNaN(pNum(row.reductionOfScope)) ? 0 : pNum(row.reductionOfScope))
            totalRevenue = totalRevenue + pNum(row.unitPrice) + pNum(row.addersToBudgetQty) + pNum(row.tAndM) + pNum(row.changeOrders) + pNum(row.reductionOfScope)
            totalRegularTime = totalRegularTime + pNum(row[51100])
            totalOvertime = totalOvertime + pNum(row[51200])
            totalBurden = totalBurden + pNum(row[51300])
            totalByod = totalByod + pNum(row[51400])
            totalPerDiem = totalPerDiem + pNum(row[51500])
            totalTruckPay = totalTruckPay + pNum(row[51600])
            totalWeldingRigPay = totalWeldingRigPay + pNum(row[51700])
            totalFieldBonus = totalFieldBonus + pNum(row[51800])
            totalLabor = totalLabor + pNum(row[51100]) + pNum(row[51200]) + pNum(row[51300]) + pNum(row[51400]) + pNum(row[51500]) + pNum(row[51600]) + pNum(row[51700]) + pNum(row[51800])
            totalTotalLaborHours = totalTotalLaborHours + pNum(row.totalLaborHours)
            totalTotalEquipmentHours = totalTotalEquipmentHours + pNum(row.totalEquipmentHours)
            totalInsideEquipmentRentals = totalInsideEquipmentRentals + pNum(row[52100])
            totalOutsideEquipmentRentals = totalOutsideEquipmentRentals + pNum(row[52200])
            totalFuel = totalFuel + pNum(row[52300])
            totalRepairs = totalRepairs + pNum(row[52400])
            totalEquipment = totalEquipment + pNum(row[52100]) + pNum(row[52200]) + pNum(row[52300]) + pNum(row[52400])
            totalMaterials = totalMaterials + pNum(row[53100])
            totalMats = totalMats + pNum(row[53200])
            totalToolsSupplies = totalToolsSupplies + pNum(row[53300])
            totalSkids = totalSkids + pNum(row[53400])
            totalMaterialsTotal = totalMaterialsTotal + pNum(row[53100]) + pNum(row[53200]) + pNum(row[53300]) + pNum(row[53400])
            totalInternalSubs = totalInternalSubs + pNum(row[54100])
            totalExternalSubs = totalExternalSubs + pNum(row[54200])
            totalHaulingTransportation = totalHaulingTransportation + pNum(row[54300])
            totalSubs = totalSubs + pNum(row[54100]) + pNum(row[54200]) + pNum(row[54300])
            totalPersonalMeals = totalPersonalMeals + pNum(row[55100])
            totalTeamMealsEntertain = totalTeamMealsEntertain + pNum(row[55200])
            totalAirfare = totalAirfare + pNum(row[55300])
            totalLodging = totalLodging + pNum(row[55400])
            totalFieldOfficeRent = totalFieldOfficeRent + pNum(row[56100])
            totalFieldOfficeUtility = totalFieldOfficeUtility + pNum(row[56200])
            totalFieldOfficeExpense = totalFieldOfficeExpense + pNum(row[56300])
            totalLabFeesTesting = totalLabFeesTesting + pNum(row[56400])
            totalSafetyPPE = totalSafetyPPE + pNum(row[56500])
            totalBondsInsurancePremiums = totalBondsInsurancePremiums + pNum(row[56600])
            totalPermits = totalPermits + pNum(row[56700])
            totalInsuranceClaims = totalInsuranceClaims + pNum(row[56800])
            totalTaxes = totalTaxes + pNum(row[57100])
            totalAccruedExpenses = totalAccruedExpenses + pNum(row[57200])
            totalWarrantyReserve = totalWarrantyReserve + pNum(row[57300])
            totalMisc = totalMisc + pNum(row[57900])
            totalOtherTravelExpenses = totalOtherTravelExpenses + pNum(row[55900])
            totalOverhead = totalOverhead + pNum(row[60900])
            totalOtherExpenses = totalOtherExpenses + pNum(row[55100]) + pNum(row[55200]) + pNum(row[55300]) + pNum(row[55400]) + pNum(row[56100]) + pNum(row[56200]) + pNum(row[56300]) + pNum(row[56400]) + pNum(row[56500]) + pNum(row[56600]) + pNum(row[56700]) + pNum(row[56800]) + pNum(row[57100]) + pNum(row[57200]) + pNum(row[57300]) + pNum(row[57900]) + pNum(row[55900])

            if (row.Status === 'Approved') {
                budgetQtyApproved = budgetQtyApproved + (isNaN(pNum(row.budgetQty)) ? 0 : pNum(row.budgetQty))
                addersToBudgetQtyApproved = addersToBudgetQtyApproved + (isNaN(pNum(row.addersToBudgetQty)) ? 0 : pNum(row.addersToBudgetQty))
                unitPriceApproved = unitPriceApproved + pNum(row.unitPrice)
                tAndMApproved = tAndMApproved + (isNaN(pNum(row.tAndM)) ? 0 : pNum(row.tAndM))
                changeOrdersApproved = changeOrdersApproved + (isNaN(pNum(row.changeOrders)) ? 0 : pNum(row.changeOrders))
                reductionOfScopeApproved = reductionOfScopeApproved + (isNaN(pNum(row.reductionOfScope)) ? 0 : pNum(row.reductionOfScope))
                totalRevenueApproved = totalRevenueApproved + pNum(row.unitPrice) + pNum(row.addersToBudgetQty) + pNum(row.tAndM) + pNum(row.changeOrders) + pNum(row.reductionOfScope)
                totalRegularTimeApproved = totalRegularTimeApproved + pNum(row[51100])
                totalOvertimeApproved = totalOvertimeApproved + pNum(row[51200])
                totalBurdenApproved = totalBurdenApproved + pNum(row[51300])
                totalByodApproved = totalByodApproved + pNum(row[51400])
                totalPerDiemApproved = totalPerDiemApproved + pNum(row[51500])
                totalTruckPayApproved = totalTruckPayApproved + pNum(row[51600])
                totalWeldingRigPayApproved = totalWeldingRigPayApproved + pNum(row[51700])
                totalFieldBonusApproved = totalFieldBonusApproved + pNum(row[51800])
                totalLaborApproved = totalLaborApproved + pNum(row[51100]) + pNum(row[51200]) + pNum(row[51300]) + pNum(row[51400]) + pNum(row[51500]) + pNum(row[51600]) + pNum(row[51700]) + pNum(row[51800])
                totalTotalLaborHoursApproved = totalTotalLaborHoursApproved + pNum(row.totalLaborHours)
                totalTotalEquipmentHoursApproved = totalTotalEquipmentHoursApproved + pNum(row.totalEquipmentHours)
                totalInsideEquipmentRentalsApproved = totalInsideEquipmentRentalsApproved + pNum(row[52100])
                totalOutsideEquipmentRentalsApproved = totalOutsideEquipmentRentalsApproved + pNum(row[52200])
                totalFuelApproved = totalFuelApproved + pNum(row[52300])
                totalRepairsApproved = totalRepairsApproved + pNum(row[52400])
                totalEquipmentApproved = totalEquipmentApproved + pNum(row[52100]) + pNum(row[52200]) + pNum(row[52300]) + pNum(row[52400])
                totalMaterialsApproved = totalMaterialsApproved + pNum(row[53100])
                totalMatsApproved = totalMatsApproved + pNum(row[53200])
                totalToolsSuppliesApproved = totalToolsSuppliesApproved + pNum(row[53300])
                totalSkidsApproved = totalSkidsApproved + pNum(row[53400])
                totalMaterialsTotalApproved = totalMaterialsTotalApproved + pNum(row[53100]) + pNum(row[53200]) + pNum(row[53300]) + pNum(row[53400])
                totalInternalSubsApproved = totalInternalSubsApproved + pNum(row[54100])
                totalExternalSubsApproved = totalExternalSubsApproved + pNum(row[54200])
                totalHaulingTransportationApproved = totalHaulingTransportationApproved + pNum(row[54300])
                totalSubsApproved = totalSubsApproved + pNum(row[54100]) + pNum(row[54200]) + pNum(row[54300])
                totalPersonalMealsApproved = totalPersonalMealsApproved + pNum(row[55100])
                totalTeamMealsEntertainApproved = totalTeamMealsEntertainApproved + pNum(row[55200])
                totalAirfareApproved = totalAirfareApproved + pNum(row[55300])
                totalLodgingApproved = totalLodgingApproved + pNum(row[55400])
                totalFieldOfficeRentApproved = totalFieldOfficeRentApproved + pNum(row[56100])
                totalFieldOfficeUtilityApproved = totalFieldOfficeUtilityApproved + pNum(row[56200])
                totalFieldOfficeExpenseApproved = totalFieldOfficeExpenseApproved + pNum(row[56300])
                totalLabFeesTestingApproved = totalLabFeesTestingApproved + pNum(row[56400])
                totalSafetyPPEApproved = totalSafetyPPEApproved + pNum(row[56500])
                totalBondsInsurancePremiumsApproved = totalBondsInsurancePremiumsApproved + pNum(row[56600])
                totalPermitsApproved = totalPermitsApproved + pNum(row[56700])
                totalInsuranceClaimsApproved = totalInsuranceClaimsApproved + pNum(row[56800])
                totalTaxesApproved = totalTaxesApproved + pNum(row[57100])
                totalAccruedExpensesApproved = totalAccruedExpensesApproved + pNum(row[57200])
                totalWarrantyReserveApproved = totalWarrantyReserveApproved + pNum(row[57300])
                totalMiscApproved = totalMiscApproved + pNum(row[57900])
                totalOtherTravelExpensesApproved = totalOtherTravelExpensesApproved + pNum(row[55900])
                totalOverheadApproved = totalOverheadApproved + pNum(row[60900])
                totalOtherExpensesApproved = totalOtherExpensesApproved + pNum(row[55100]) + pNum(row[55200]) + pNum(row[55300]) + pNum(row[55400]) + pNum(row[56100]) + pNum(row[56200]) + pNum(row[56300]) + pNum(row[56400]) + pNum(row[56500]) + pNum(row[56600]) + pNum(row[56700]) + pNum(row[56800]) + pNum(row[57100]) + pNum(row[57200]) + pNum(row[57300]) + pNum(row[57900]) + pNum(row[55900])
            } else if (row.Status === 'Pending - Performed' || row.Status === 'Pending - Not Performed') {
                budgetQtyPending = budgetQtyPending + (isNaN(pNum(row.budgetQty)) ? 0 : pNum(row.budgetQty))
                addersToBudgetQtyPending = addersToBudgetQtyPending + (isNaN(pNum(row.addersToBudgetQty)) ? 0 : pNum(row.addersToBudgetQty))
                unitPricePending = unitPricePending + pNum(row.unitPrice)
                tAndMPending = tAndMPending + (isNaN(pNum(row.tAndM)) ? 0 : pNum(row.tAndM))
                changeOrdersPending = changeOrdersPending + (isNaN(pNum(row.changeOrders)) ? 0 : pNum(row.changeOrders))
                reductionOfScopePending = reductionOfScopePending + (isNaN(pNum(row.reductionOfScope)) ? 0 : pNum(row.reductionOfScope))
                totalRevenuePending = totalRevenuePending + pNum(row.unitPrice) + pNum(row.addersToBudgetQty) + pNum(row.tAndM) + pNum(row.changeOrders) + pNum(row.reductionOfScope)
                totalRegularTimePending = totalRegularTimePending + pNum(row[51100])
                totalOvertimePending = totalOvertimePending + pNum(row[51200])
                totalBurdenPending = totalBurdenPending + pNum(row[51300])
                totalByodPending = totalByodPending + pNum(row[51400])
                totalPerDiemPending = totalPerDiemPending + pNum(row[51500])
                totalTruckPayPending = totalTruckPayPending + pNum(row[51600])
                totalWeldingRigPayPending = totalWeldingRigPayPending + pNum(row[51700])
                totalFieldBonusPending = totalFieldBonusPending + pNum(row[51800])
                totalLaborPending = totalLaborPending + pNum(row[51100]) + pNum(row[51200]) + pNum(row[51300]) + pNum(row[51400]) + pNum(row[51500]) + pNum(row[51600]) + pNum(row[51700]) + pNum(row[51800])
                totalTotalLaborHoursPending = totalTotalLaborHoursPending + pNum(row.totalLaborHours)
                totalTotalEquipmentHoursPending = totalTotalEquipmentHoursPending + pNum(row.totalEquipmentHours)
                totalInsideEquipmentRentalsPending = totalInsideEquipmentRentalsPending + pNum(row[52100])
                totalOutsideEquipmentRentalsPending = totalOutsideEquipmentRentalsPending + pNum(row[52200])
                totalFuelPending = totalFuelPending + pNum(row[52300])
                totalRepairsPending = totalRepairsPending + pNum(row[52400])
                totalEquipmentPending = totalEquipmentPending + pNum(row[52100]) + pNum(row[52200]) + pNum(row[52300]) + pNum(row[52400])
                totalMaterialsPending = totalMaterialsPending + pNum(row[53100])
                totalMatsPending = totalMatsPending + pNum(row[53200])
                totalToolsSuppliesPending = totalToolsSuppliesPending + pNum(row[53300])
                totalSkidsPending = totalSkidsPending + pNum(row[53400])
                totalMaterialsTotalPending = totalMaterialsTotalPending + pNum(row[53100]) + pNum(row[53200]) + pNum(row[53300]) + pNum(row[53400])
                totalInternalSubsPending = totalInternalSubsPending + pNum(row[54100])
                totalExternalSubsPending = totalExternalSubsPending + pNum(row[54200])
                totalHaulingTransportationPending = totalHaulingTransportationPending + pNum(row[54300])
                totalSubsPending = totalSubsPending + pNum(row[54100]) + pNum(row[54200]) + pNum(row[54300])
                totalPersonalMealsPending = totalPersonalMealsPending + pNum(row[55100])
                totalTeamMealsEntertainPending = totalTeamMealsEntertainPending + pNum(row[55200])
                totalAirfarePending = totalAirfarePending + pNum(row[55300])
                totalLodgingPending = totalLodgingPending + pNum(row[55400])
                totalFieldOfficeRentPending = totalFieldOfficeRentPending + pNum(row[56100])
                totalFieldOfficeUtilityPending = totalFieldOfficeUtilityPending + pNum(row[56200])
                totalFieldOfficeExpensePending = totalFieldOfficeExpensePending + pNum(row[56300])
                totalLabFeesTestingPending = totalLabFeesTestingPending + pNum(row[56400])
                totalSafetyPPEPending = totalSafetyPPEPending + pNum(row[56500])
                totalBondsInsurancePremiumsPending = totalBondsInsurancePremiumsPending + pNum(row[56600])
                totalPermitsPending = totalPermitsPending + pNum(row[56700])
                totalInsuranceClaimsPending = totalInsuranceClaimsPending + pNum(row[56800])
                totalTaxesPending = totalTaxesPending + pNum(row[57100])
                totalAccruedExpensesPending = totalAccruedExpensesPending + pNum(row[57200])
                totalWarrantyReservePending = totalWarrantyReservePending + pNum(row[57300])
                totalMiscPending = totalMiscPending + pNum(row[57900])
                totalOtherTravelExpensesPending = totalOtherTravelExpensesPending + pNum(row[55900])
                totalOverheadPending = totalOverheadPending + pNum(row[60900])
                totalOtherExpensesPending = totalOtherExpensesPending + pNum(row[55100]) + pNum(row[55200]) + pNum(row[55300]) + pNum(row[55400]) + pNum(row[56100]) + pNum(row[56200]) + pNum(row[56300]) + pNum(row[56400]) + pNum(row[56500]) + pNum(row[56600]) + pNum(row[56700]) + pNum(row[56800]) + pNum(row[57100]) + pNum(row[57200]) + pNum(row[57300]) + pNum(row[57900]) + pNum(row[55900])
            }
        })

        setTotalAddersToBudgetQty(fNum(addersToBudgetQty))
        setTotalBudgetQty(fNum(budgetQty))
        setTotalUnitPrice(fNum(unitPrice))
        setTotalTAndM(fNum(tAndM))
        setTotalChangeOrders(fNum(changeOrders))
        setTotalReductionOfScope(fNum(reductionOfScope))
        setTotalTotalRevenue(fNum(totalRevenue))
        setTotalRegularTime(fNum(totalRegularTime))
        setTotalOvertime(fNum(totalOvertime))
        setTotalBurden(fNum(totalBurden))
        setTotalByod(fNum(totalByod))
        setTotalPerDiem(fNum(totalPerDiem))
        setTotalTruckPay(fNum(totalTruckPay))
        setTotalWeldingRigPay(fNum(totalWeldingRigPay))
        setTotalFieldBonus(fNum(totalFieldBonus))
        setTotalLabor(fNum(totalLabor))
        setTotalTotalLaborHours(fNum(totalTotalLaborHours))
        setTotalTotalEquipmentHours(fNum(totalTotalEquipmentHours))
        setTotalInsideEquipmentRentals(fNum(totalInsideEquipmentRentals))
        setTotalOutsideEquipmentRentals(fNum(totalOutsideEquipmentRentals))
        setTotalFuel(fNum(totalFuel))
        setTotalRepairs(fNum(totalRepairs))
        setTotalEquipment(fNum(totalEquipment))
        setTotalMaterials(fNum(totalMaterials))
        setTotalMats(fNum(totalMats))
        setTotalToolsSupplies(fNum(totalToolsSupplies))
        setTotalSkids(fNum(totalSkids))
        setTotalMaterialsTotal(fNum(totalMaterialsTotal))
        setTotalInternalSubs(fNum(totalInternalSubs))
        setTotalExternalSubs(fNum(totalExternalSubs))
        setTotalHaulingTransportation(fNum(totalHaulingTransportation))
        setTotalSubs(fNum(totalSubs))
        setTotalPersonalMeals(fNum(totalPersonalMeals))
        setTotalTeamMealsEntertain(fNum(totalTeamMealsEntertain))
        setTotalAirfare(fNum(totalAirfare))
        setTotalLodging(fNum(totalLodging))
        setTotalFieldOfficeRent(fNum(totalFieldOfficeRent))
        setTotalFieldOfficeUtility(fNum(totalFieldOfficeUtility))
        setTotalFieldOfficeExpense(fNum(totalFieldOfficeExpense))
        setTotalLabFeesTesting(fNum(totalLabFeesTesting))
        setTotalSafetyPPE(fNum(totalSafetyPPE))
        setTotalBondsInsurancePremiums(fNum(totalBondsInsurancePremiums))
        setTotalPermits(fNum(totalPermits))
        setTotalInsuranceClaims(fNum(totalInsuranceClaims))
        setTotalTaxes(fNum(totalTaxes))
        setTotalAccruedExpenses(fNum(totalAccruedExpenses))
        setTotalWarrantyReserve(fNum(totalWarrantyReserve))
        setTotalMisc(fNum(totalMisc))
        setTotalOtherTravelExpenses(fNum(totalOtherTravelExpenses))
        setTotalOverhead(fNum(totalOverhead))
        setTotalOther(fNum(totalOtherExpenses))
        setTotalTotalCosts(fNum(totalLabor + totalEquipment + totalMaterialsTotal + totalSubs + totalOtherExpenses))
        setTotalGrossProfit(fNum(totalRevenue - totalLabor - totalEquipment - totalMaterialsTotal - totalSubs - totalOtherExpenses))
        setTotalGpPercent(totalRevenue == 0 ? '-' : fNum(((totalRevenue - totalLabor - totalEquipment - totalMaterialsTotal - totalSubs - totalOtherExpenses) / totalRevenue * 100).toFixed()) + '%')

        setTotalUnitPricePending(fNum(unitPricePending))
        setTotalTAndMPending(fNum(tAndMPending))
        setTotalChangeOrdersPending(fNum(changeOrdersPending))
        setTotalReductionOfScopePending(fNum(reductionOfScopePending))
        setTotalTotalRevenuePending(fNum(totalRevenuePending))
        setTotalRegularTimePending(fNum(totalRegularTimePending))
        setTotalOvertimePending(fNum(totalOvertimePending))
        setTotalBurdenPending(fNum(totalBurdenPending))
        setTotalByodPending(fNum(totalByodPending))
        setTotalPerDiemPending(fNum(totalPerDiemPending))
        setTotalTruckPayPending(fNum(totalTruckPayPending))
        setTotalWeldingRigPayPending(fNum(totalWeldingRigPayPending))
        setTotalFieldBonusPending(fNum(totalFieldBonusPending))
        setTotalLaborPending(fNum(totalLaborPending))
        setTotalTotalLaborHoursPending(fNum(totalTotalLaborHoursPending))
        setTotalTotalEquipmentHoursPending(fNum(totalTotalEquipmentHoursPending))
        setTotalInsideEquipmentRentalsPending(fNum(totalInsideEquipmentRentalsPending))
        setTotalOutsideEquipmentRentalsPending(fNum(totalOutsideEquipmentRentalsPending))
        setTotalFuelPending(fNum(totalFuelPending))
        setTotalRepairsPending(fNum(totalRepairsPending))
        setTotalEquipmentPending(fNum(totalEquipmentPending))
        setTotalMaterialsPending(fNum(totalMaterialsPending))
        setTotalMatsPending(fNum(totalMatsPending))
        setTotalToolsSuppliesPending(fNum(totalToolsSuppliesPending))
        setTotalSkidsPending(fNum(totalSkidsPending))
        setTotalMaterialsTotalPending(fNum(totalMaterialsTotalPending))
        setTotalInternalSubsPending(fNum(totalInternalSubsPending))
        setTotalExternalSubsPending(fNum(totalExternalSubsPending))
        setTotalHaulingTransportationPending(fNum(totalHaulingTransportationPending))
        setTotalSubsPending(fNum(totalSubsPending))
        setTotalPersonalMealsPending(fNum(totalPersonalMealsPending))
        setTotalTeamMealsEntertainPending(fNum(totalTeamMealsEntertainPending))
        setTotalAirfarePending(fNum(totalAirfarePending))
        setTotalLodgingPending(fNum(totalLodgingPending))
        setTotalFieldOfficeRentPending(fNum(totalFieldOfficeRentPending))
        setTotalFieldOfficeUtilityPending(fNum(totalFieldOfficeUtilityPending))
        setTotalFieldOfficeExpensePending(fNum(totalFieldOfficeExpensePending))
        setTotalLabFeesTestingPending(fNum(totalLabFeesTestingPending))
        setTotalSafetyPPEPending(fNum(totalSafetyPPEPending))
        setTotalBondsInsurancePremiumsPending(fNum(totalBondsInsurancePremiumsPending))
        setTotalPermitsPending(fNum(totalPermitsPending))
        setTotalInsuranceClaimsPending(fNum(totalInsuranceClaimsPending))
        setTotalTaxesPending(fNum(totalTaxesPending))
        setTotalAccruedExpensesPending(fNum(totalAccruedExpensesPending))
        setTotalWarrantyReservePending(fNum(totalWarrantyReservePending))
        setTotalMiscPending(fNum(totalMiscPending))
        setTotalOtherTravelExpensesPending(fNum(totalOtherTravelExpensesPending))
        setTotalOverheadPending(fNum(totalOverheadPending))
        setTotalOtherPending(fNum(totalOtherExpensesPending))
        setTotalTotalCostsPending(fNum(totalLaborPending + totalEquipmentPending + totalMaterialsTotalPending + totalSubsPending + totalOtherExpensesPending))
        setTotalGrossProfitPending(fNum(totalRevenuePending - totalLaborPending - totalEquipmentPending - totalMaterialsTotalPending - totalSubsPending - totalOtherExpensesPending))
        setTotalGpPercentPending(totalRevenuePending == 0 ? '-' : fNum(((totalRevenuePending - totalLaborPending - totalEquipmentPending - totalMaterialsTotalPending - totalSubsPending - totalOtherExpensesPending) / totalRevenuePending * 100).toFixed()) + '%')

        setTotalUnitPriceApproved(fNum(unitPriceApproved))
        setTotalTAndMApproved(fNum(tAndMApproved))
        setTotalChangeOrdersApproved(fNum(changeOrdersApproved))
        setTotalReductionOfScopeApproved(fNum(reductionOfScopeApproved))
        setTotalTotalRevenueApproved(fNum(totalRevenueApproved))
        setTotalRegularTimeApproved(fNum(totalRegularTimeApproved))
        setTotalOvertimeApproved(fNum(totalOvertimeApproved))
        setTotalBurdenApproved(fNum(totalBurdenApproved))
        setTotalByodApproved(fNum(totalByodApproved))
        setTotalPerDiemApproved(fNum(totalPerDiemApproved))
        setTotalTruckPayApproved(fNum(totalTruckPayApproved))
        setTotalWeldingRigPayApproved(fNum(totalWeldingRigPayApproved))
        setTotalFieldBonusApproved(fNum(totalFieldBonusApproved))
        setTotalLaborApproved(fNum(totalLaborApproved))
        setTotalTotalLaborHoursApproved(fNum(totalTotalLaborHoursApproved))
        setTotalTotalEquipmentHoursApproved(fNum(totalTotalEquipmentHoursApproved))
        setTotalInsideEquipmentRentalsApproved(fNum(totalInsideEquipmentRentalsApproved))
        setTotalOutsideEquipmentRentalsApproved(fNum(totalOutsideEquipmentRentalsApproved))
        setTotalFuelApproved(fNum(totalFuelApproved))
        setTotalRepairsApproved(fNum(totalRepairsApproved))
        setTotalEquipmentApproved(fNum(totalEquipmentApproved))
        setTotalMaterialsApproved(fNum(totalMaterialsApproved))
        setTotalMatsApproved(fNum(totalMatsApproved))
        setTotalToolsSuppliesApproved(fNum(totalToolsSuppliesApproved))
        setTotalSkidsApproved(fNum(totalSkidsApproved))
        setTotalMaterialsTotalApproved(fNum(totalMaterialsTotalApproved))
        setTotalInternalSubsApproved(fNum(totalInternalSubsApproved))
        setTotalExternalSubsApproved(fNum(totalExternalSubsApproved))
        setTotalHaulingTransportationApproved(fNum(totalHaulingTransportationApproved))
        setTotalSubsApproved(fNum(totalSubsApproved))
        setTotalPersonalMealsApproved(fNum(totalPersonalMealsApproved))
        setTotalTeamMealsEntertainApproved(fNum(totalTeamMealsEntertainApproved))
        setTotalAirfareApproved(fNum(totalAirfareApproved))
        setTotalLodgingApproved(fNum(totalLodgingApproved))
        setTotalFieldOfficeRentApproved(fNum(totalFieldOfficeRentApproved))
        setTotalFieldOfficeUtilityApproved(fNum(totalFieldOfficeUtilityApproved))
        setTotalFieldOfficeExpenseApproved(fNum(totalFieldOfficeExpenseApproved))
        setTotalLabFeesTestingApproved(fNum(totalLabFeesTestingApproved))
        setTotalSafetyPPEApproved(fNum(totalSafetyPPEApproved))
        setTotalBondsInsurancePremiumsApproved(fNum(totalBondsInsurancePremiumsApproved))
        setTotalPermitsApproved(fNum(totalPermitsApproved))
        setTotalInsuranceClaimsApproved(fNum(totalInsuranceClaimsApproved))
        setTotalTaxesApproved(fNum(totalTaxesApproved))
        setTotalAccruedExpensesApproved(fNum(totalAccruedExpensesApproved))
        setTotalWarrantyReserveApproved(fNum(totalWarrantyReserveApproved))
        setTotalMiscApproved(fNum(totalMiscApproved))
        setTotalOtherTravelExpensesApproved(fNum(totalOtherTravelExpensesApproved))
        setTotalOverheadApproved(fNum(totalOverheadApproved))
        setTotalOtherApproved(fNum(totalOtherExpensesApproved))
        setTotalTotalCostsApproved(fNum(totalLaborApproved + totalEquipmentApproved + totalMaterialsTotalApproved + totalSubsApproved + totalOtherExpensesApproved))
        setTotalGrossProfitApproved(fNum(totalRevenueApproved - totalLaborApproved - totalEquipmentApproved - totalMaterialsTotalApproved - totalSubsApproved - totalOtherExpensesApproved))
        setTotalGpPercentApproved(totalRevenueApproved == 0 ? '-' : fNum(((totalRevenueApproved - totalLaborApproved - totalEquipmentApproved - totalMaterialsTotalApproved - totalSubsApproved - totalOtherExpensesApproved) / totalRevenueApproved * 100).toFixed()) + '%')
    }

    useEffect(() => {
        setupPage()
    }, [jobUserData])

    const setupPage = () => {
        if (jobUserData && jobUserData.length > 0) {
            // The per-field → per-line fold lives in helpers/cologRows so the
            // Overview download reads the same CO log this tab shows.
            const coRows = jobUserData.filter((d) => d?.Forecast_Tab === 'CO Log' || d?.Forecast_Tab === 'CO LOG')
            const userData = {}
            buildCOLogRows(jobUserData).forEach((r) => { userData[r.id] = r })
            //console.log('user data rows', rows, userData)
            //console.log('user data rows', userData)
            const compare = (a, b) => {
                if (!a.Row_Label) return 1;  // If a.coNo is blank, push it to the end
                if (!b.Row_Label) return -1; // If b.coNo is blank, push it to the end

                return parseInt(a.Row_Label) > parseInt(b.Row_Label) ? 1 : -1;
            };

            const coSect = {}
            //console.log('user data', userData)
            Object.values(userData).forEach((row) => {
                if (coSect[row.coNo]) {
                    const details = Object.keys(row)
                    details.forEach((d) => {
                        if (d && coSect[row.coNo][d]) {
                            //console.log('co sect piece', coSect[row.coNo], row, d)
                            coSect[row.coNo][d] = isNaN(pNum(row[d])) && d != 'coNo' && d != 'coNoItemDescription' && d != 'coNoPhase' && d != 'id' && d != 'status' ? row[d] : fNum(pNum(coSect[row.coNo][d]) + pNum(row[d]))
                        } else {
                            //console.log('co sect piece 2', coSect[row.coNo], row, d)
                            coSect[row.coNo][d] = isNaN(pNum(row[d])) && d != 'coNo' && d != 'coNoItemDescription' && d != 'coNoPhase' && d != 'id' && d != 'status' ? row[d] : fNum(pNum(row[d]))
                        }
                    })
                } else if (row) {
                    coSect[row.coNo] = JSON.parse(JSON.stringify(row))
                    // const rowPieces = Object.keys(row)
                    // rowPieces.forEach((d) => {
                    //     coSect[row.coNo][d] = isNaN(pNum(row[d])) ? row[d] : fNum(pNum(row[d]))
                    // })

                }
            })

            setCORows(coRows)
            //console.log('co sect', coSect, Object.values(coSect))
            const sortedSections = sortData(Object.values(coSect));
            const sortedUserData = sortData(Object.values(userData));
            setCOSections(sortedSections)
            setCOLogs(sortedUserData)
            setCOLogsImage(divideIntoSections(sortedUserData))
            calculateTotals(userData)
        } else {
            // Clear colog state when jobUserData is empty
            setCORows([])
            setCOSections([])
            setCOLogs([])
            setCOLogsImage([])
        }
    }

    const s = (w = null) => StyleSheet.create({
        topContainer: {
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            borderRadius: 5
        },
        container: {
            flexDirection: 'row',
            paddingBottom: 0,
        },
        smallContainer: {

        },
        span2: {
            width: 200,
            alignItems: 'center',
            fontSize: 20,
            padding: 5,
            borderColor: '#aeadaf',
            borderWidth: 1

        },
        span: {
            width: 100,
            alignItems: 'center',
            fontSize: 20,
            padding: 5,
            textAlign: 'right',
            borderColor: '#aeadaf',
            borderWidth: 1
        },
        span3: {
            width: 300,
            alignItems: 'center',
            fontSize: 20,
            padding: 5,
            borderColor: '#aeadaf',
            borderWidth: 1
        },
        span2T: {
            width: 200,
            alignItems: 'center',
            fontSize: 16,
            padding: 5,
            borderColor: '#aeadaf',
            borderWidth: 1
        },
        spanT: {
            width: w ? w : 100,
            alignItems: 'center',
            fontSize: 13,
            padding: 10,
            textAlign: 'right',
            justifyContent: 'flex-end',
            borderBottomWidth: 1,
            borderBottomColor: '#e2e8f0',
            zIndex: 1
        },
        spanH: {
            width: w ? w : 100,
            alignItems: 'center',
            fontSize: 13,
            fontWeight: '600',
            padding: 12,
            textAlign: 'right',
            borderBottomWidth: 2,
            borderBottomColor: '#2563eb',
            backgroundColor: '#f8fafc',
            color: '#1e293b',
        },
        spanHI: {
            width: w ? w : 100,
            alignItems: 'center',
            fontSize: 16,
            padding: 5,
            borderWidthRight: 1,
            borderColor: '#aeadaf',
            flexDirection: 'row',
            justifyContent: 'space-between',
            display: 'flex'

        },
        span3T: {
            width: 300,
            alignItems: 'center',
            fontSize: 10,
            padding: 5,
            borderColor: '#aeadaf',
            borderWidth: 1
        },
        card: {
            width: 400,
            //boxShadow: "10px 10px 17px -12px rgba(0,0,0,0.75)",
            borderRadius: 5,
            padding: 10,
            borderWidth: .5,
            borderColor: '#aeadaf',

        },
        span1T: {
            width: w ? w : 100,
            maxWidth: w ? w : 100,
            alignItems: 'center',
            fontSize: 16,
            padding: 5,
            textAlign: 'right',
            borderColor: '#aeadaf',
            borderWidth: 1,
            backgroundColor: '#efefef',
            zIndex: 1,
            display: 'flex',
            justifyContent: 'flex-end'
        },
        dropdown: {
            height: 40,
            width: w ? w : 100,
            borderColor: 'white',
            paddingHorizontal: 8,
            borderColor: '#aeadaf',
            borderWidth: 1,
        },
        dropdownH: {
            height: 40,
            width: w ? w : 100,
            borderColor: 'white',
            paddingHorizontal: 8,
            borderColor: '#aeadaf',
            borderWidth: 1,
            backgroundColor: '#efefef',
        },
        icon: {
            marginRight: 5,
        },
        label: {
            position: 'absolute',
            backgroundColor: 'white',
            left: 22,
            top: 8,
            zIndex: 999,
            paddingHorizontal: 8,
            fontSize: 14,
        },
        placeholderStyle: {
            fontSize: 16,
            fontWeight: '300',

        },
        selectedTextStyle: {
            fontSize: 16,
            color: 'black'
        },
        tabItem: {
            paddingVertical: 12,
            paddingHorizontal: 16,
            borderBottomWidth: 2,
            borderBottomColor: 'transparent',
        },
        activeTab: {
            borderBottomColor: '#192440',
        },
        tabText: {
            fontSize: 16,
            color: '#888',
        },
        activeText: {
            color: '#000',
            fontWeight: '600',
        },

    })

    const Header = () => {
        return (
            <View style={[s().container, { position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 10 }]}>
                <Text style={s(80).spanH}>
                    CO NO.
                </Text>
                <Text style={s(80).spanH}>
                    Phase
                </Text>
                <Text style={s(300).spanH}>
                    Item Description
                </Text>
                <Text style={s(200).spanH}>
                    Status
                </Text>
                <View style={{ width: 20 }}></View>
                {/* <Text style={s().spanH}>
            Budget Qty
        </Text>
        <Text style={s().spanH}>
            Original $
        </Text>
        <Text style={s().spanH}>
            Completed Qty
        </Text>
        <Text style={s().spanH}>
            Completed $
        </Text>
        <Text style={s().spanH}>
            Remaining Qty
        </Text> */}
                {/* <Text style={s().spanH}>
            Qty Budget + Fcst
        </Text>
        <Text style={s().spanH}>
            $ Budget + Fcst
        </Text> */}
                <Text style={s().spanH}>
                    Unit Price Adders
                </Text>
                <Text style={s().spanH}>
                    T&M
                </Text>
                <Text style={s().spanH}>
                    Change Orders
                </Text>
                <Text style={s().spanH}>
                    Reduction of Scope
                </Text>
                <Text style={s().spanH}>
                    Total Revenue
                </Text>
                <View style={{ width: 20 }}></View>
                {totalExpanded ? <View style={s().container}>
                    <Text style={s().spanHI}>Units
                        <Icon3
                            name={unitsExpanded ? "MdExpandMore" : "MdChevronRight"}
                            size={20}
                            color="black"
                            onClick={() => {
                                setUnitsExpanded(!unitsExpanded)
                            }}
                        />
                    </Text>
                    {unitsExpanded ? <View style={s().container}>
                        <Text style={s().spanH}>
                            Budgeted Qty
                        </Text>
                        <Text style={s().spanH}>
                            Labor Hours
                        </Text>
                        <Text style={s().spanH}>
                            Equipment Hours
                        </Text>
                    </View> : null}
                    <Text style={s().spanHI}>Labor
                        <Icon3
                            name={laborExpanded ? "MdExpandMore" : "MdChevronRight"}
                            size={20}
                            color="black"
                            onClick={() => {
                                setLaborExpanded(!laborExpanded)
                            }}
                        />
                    </Text>
                    {laborExpanded ? <View style={s().container}>
                        <Text style={s().spanH}>
                            51100 Regular Time
                        </Text>
                        <Text style={s().spanH}>
                            51200 Overtime
                        </Text>
                        <Text style={s().spanH}>
                            51300 Burden
                        </Text>
                        <Text style={s().spanH}>
                            51400 BYOD
                        </Text>
                        <Text style={s().spanH}>
                            51500 Per Diem
                        </Text>
                        <Text style={s().spanH}>
                            51600 Truck Pay
                        </Text>
                        <Text style={s().spanH}>
                            51700 Welding Rig Pay
                        </Text>
                        <Text style={s().spanH}>
                            51800 Field Bonus
                        </Text>
                    </View> : null}
                    <Text style={s().spanHI}>
                        <Text>Equipment</Text>
                        <Icon3
                            name={equipmentExpanded ? "MdExpandMore" : "MdChevronRight"}
                            size={20}
                            color="black"
                            onClick={() => {
                                setEquipmentExpanded(!equipmentExpanded)
                            }}
                        />
                    </Text>
                    {equipmentExpanded ? <View style={s().container}>
                        <Text style={s().spanH}>
                            52100 Inside Equipment Rental
                        </Text>
                        <Text style={s().spanH}>
                            52200 Outside Equipment Rental
                        </Text>
                        <Text style={s().spanH}>
                            52300 Fuel
                        </Text>
                        <Text style={s().spanH}>
                            52400 Repairs
                        </Text>
                        {/* <Text style={s().spanH}>
                    Total Equipment
                </Text> */}
                    </View> : null}
                    <Text style={s().spanHI}>
                        <Text>Materials</Text>
                        <Icon3
                            name={materialsExpanded ? "MdExpandMore" : "MdChevronRight"}
                            size={20}
                            color="black"
                            onClick={() => {
                                setMaterialsExpanded(!materialsExpanded)
                            }}
                        />
                    </Text>
                    {materialsExpanded ? <View style={s().container}>
                        <Text style={s().spanH}>
                            53100 Materials
                        </Text>
                        <Text style={s().spanH}>
                            53200 Mats
                        </Text>
                        <Text style={s().spanH}>
                            53300 Tools/Supplies
                        </Text>
                        <Text style={s().spanH}>
                            53400 Skids
                        </Text>
                    </View> : null}
                    <Text style={s().spanHI}>Subs
                        <Icon3
                            name={subsExpanded ? "MdExpandMore" : "MdChevronRight"}
                            size={20}
                            color="black"
                            onClick={() => {
                                setSubsExpanded(!subsExpanded)
                            }}
                        />
                    </Text>
                    {subsExpanded ? <View style={s().container}>
                        <Text style={s().spanH}>
                            54100 Internal Subs
                        </Text>
                        <Text style={s().spanH}>
                            54200 External Subs
                        </Text>
                        <Text style={s().spanH}>
                            54300 Hauling/Transportation
                        </Text>
                    </View> : null}
                    <Text style={s().spanHI}>Other Expenses
                        <Icon3
                            name={otherExpanded ? "MdExpandMore" : "MdChevronRight"}
                            size={20}
                            color="black"
                            onClick={() => {
                                setOtherExpanded(!otherExpanded)
                            }}
                        />
                    </Text>
                    {otherExpanded ? <View style={s().container}>
                        <Text style={s().spanH}>
                            55100 Personal Meals
                        </Text>
                        <Text style={s().spanH}>
                            55200 Team Meals/Entertainment
                        </Text>
                        <Text style={s().spanH}>
                            55300 Airfare
                        </Text>
                        <Text style={s().spanH}>
                            55400 Lodging
                        </Text>
                        <Text style={s().spanH}>
                            55900 Other Travel Expenses
                        </Text>
                        <Text style={s().spanH}>
                            56100 Field Office Rent
                        </Text>
                        <Text style={s().spanH}>
                            56200 Field Office Utility
                        </Text>
                        <Text style={s().spanH}>
                            56300 Field Office Expense
                        </Text>
                        <Text style={s().spanH}>
                            56400 Lab Fees/Testing
                        </Text>
                        <Text style={s().spanH}>
                            56500 Safety/PPE
                        </Text>
                        <Text style={s().spanH}>
                            56600 Bonds/Insurance Premiums
                        </Text>
                        <Text style={s().spanH}>
                            56700 Permits
                        </Text>
                        <Text style={s().spanH}>
                            56800 Insurance Claims
                        </Text>
                        <Text style={s().spanH}>
                            57100 Taxes
                        </Text>
                        <Text style={s().spanH}>
                            57200 Accrued Expenses
                        </Text>
                        <Text style={s().spanH}>
                            57300 Warranty Reserve
                        </Text>
                        <Text style={s().spanH}>
                            57900 Misc
                        </Text>
                    </View> : null}
                    <Text style={s().spanHI}>Overhead Allocation
                    </Text>
                </View> : null}
                <Text style={s().spanH}>
                    Total Costs
                    <Icon3
                        name={totalExpanded ? "MdExpandMore" : "MdChevronRight"}
                        size={20}
                        color="black"
                        onClick={() => {
                            setTotalExpanded(!totalExpanded)
                        }}
                    />
                </Text>
                <Text style={s().spanH}>
                    Gross Margin
                </Text>
                <Text style={s().spanH}>
                    GM %
                </Text>
                <Text style={s(350).spanH}>
                    Additional Notes
                </Text>
                {/* <Text style={s().spanH}>
            CO Billings
        </Text>
        <Text style={s().spanH}>
            Total CO Bilings Amount
        </Text>
        <Text style={s().spanH}>
            Total CO Left to Bill
        </Text>
        <Text style={s().spanH}>
            Reconciliation Comments
        </Text> */}
            </View>
        )
    }

    const Footer = () => {
        return (
            <View>
                <View style={s().container}>
                    <View style={{ width: 460 }}></View>
                    <Text style={s(200).spanH}>
                        Change Order Total
                    </Text>
                    <View style={{ width: 20 }}></View>
                    <Text style={s().spanH}>
                        {totalUnitPrice}
                    </Text>
                    <Text style={s().spanH}>
                        {totalTAndM}
                    </Text>
                    <Text style={s().spanH}>
                        {totalChangeOrders}
                    </Text>
                    <Text style={s().spanH}>
                        {totalReductionOfScope}
                    </Text>
                    <Text style={s().spanH}>
                        {totalTotalRevenue}
                    </Text>
                    <View style={{ width: 20 }}></View>
                    {totalExpanded ? <View style={s().container}>
                        <Text style={s().spanH}>
                            {totalTotalQty}
                        </Text>
                        {unitsExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                            </Text>
                            <Text style={s().spanH}>
                                {totalTotalLaborHours}
                            </Text>
                            <Text style={s().spanH}>
                                {totalTotalEquipmentHours}
                            </Text></View> : null}
                        <Text style={s().spanH}>
                            {totalLabor}
                        </Text>
                        {laborExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalRegularTime}
                            </Text>
                            <Text style={s().spanH}>
                                {totalOvertime}
                            </Text>
                            <Text style={s().spanH}>
                                {totalBurden}
                            </Text>
                            <Text style={s().spanH}>
                                {totalByod}
                            </Text>
                            <Text style={s().spanH}>
                                {totalPerDiem}
                            </Text>
                            <Text style={s().spanH}>
                                {totalTruckPay}
                            </Text>
                            <Text style={s().spanH}>
                                {totalWeldingRigPay}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFieldBonus}
                            </Text>
                        </View> : null}
                        <Text style={s().spanH}>
                            {totalEquipment}
                        </Text>
                        {equipmentExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalInsideEquipmentRentals}
                            </Text>
                            <Text style={s().spanH}>
                                {totalOutsideEquipmentRentals}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFuel}
                            </Text>
                            <Text style={s().spanH}>
                                {totalRepairs}
                            </Text>
                            {/* <Text style={s().spanH}>
                    {totalEquipment}
                </Text> */}
                        </View> : null}
                        <Text style={s().spanH}>
                            {totalMaterialsTotal}
                        </Text>
                        {materialsExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalMaterials}
                            </Text>
                            <Text style={s().spanH}>
                                {totalMats}
                            </Text>
                            <Text style={s().spanH}>
                                {totalToolsSupplies}
                            </Text>
                            <Text style={s().spanH}>
                                {totalSkids}
                            </Text>
                        </View> : null}
                        <Text style={s().spanH}>
                            {totalSubs}
                        </Text>
                        {subsExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalInternalSubs}
                            </Text>
                            <Text style={s().spanH}>
                                {totalExternalSubs}
                            </Text>
                            <Text style={s().spanH}>
                                {totalHaulingTransportation}
                            </Text>
                        </View> : null}
                        <Text style={s().spanH}>
                            {totalOther}
                        </Text>
                        {otherExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalPersonalMeals}
                            </Text>
                            <Text style={s().spanH}>
                                {totalTeamMealsEntertain}
                            </Text>
                            <Text style={s().spanH}>
                                {totalAirfare}
                            </Text>
                            <Text style={s().spanH}>
                                {totalLodging}
                            </Text>
                            <Text style={s().spanH}>
                                {totalOtherTravelExpenses}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFieldOfficeRent}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFieldOfficeUtility}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFieldOfficeExpense}
                            </Text>
                            <Text style={s().spanH}>
                                {totalLabFeesTesting}
                            </Text>
                            <Text style={s().spanH}>
                                {totalSafetyPPE}
                            </Text>
                            <Text style={s().spanH}>
                                {totalBondsInsurancePremiums}
                            </Text>
                            <Text style={s().spanH}>
                                {totalPermits}
                            </Text>
                            <Text style={s().spanH}>
                                {totalInsuranceClaims}
                            </Text>
                            <Text style={s().spanH}>
                                {totalTaxes}
                            </Text>
                            <Text style={s().spanH}>
                                {totalAccruedExpenses}
                            </Text>
                            <Text style={s().spanH}>
                                {totalWarrantyReserve}
                            </Text>
                            <Text style={s().spanH}>
                                {totalMisc}
                            </Text>
                            <Text style={s().spanH}>
                                {totalOverhead}
                            </Text>
                        </View> : null}
                    </View> : null}
                    <Text style={s().spanH}>
                        {totalTotalCosts}
                    </Text>
                    <Text style={s().spanH}>
                        {totalGrossProfit}
                    </Text>
                    <Text style={s().spanH}>
                        {totalGpPercent}
                    </Text>
                </View>
                <View style={s().container}>
                    <View style={{ width: 360 }}></View>
                    <Text style={s(300).spanH}>
                        Approved Total
                    </Text>
                    <View style={{ width: 20 }}></View>
                    <Text style={s().spanH}>
                        {totalUnitPriceApproved}
                    </Text>
                    <Text style={s().spanH}>
                        {totalTAndMApproved}
                    </Text>
                    <Text style={s().spanH}>
                        {totalChangeOrdersApproved}
                    </Text>
                    <Text style={s().spanH}>
                        {totalReductionOfScopeApproved}
                    </Text>
                    <Text style={s().spanH}>
                        {totalTotalRevenueApproved}
                    </Text>
                    <View style={{ width: 20 }}></View>
                    {totalExpanded ? <View style={s().container}>
                        <Text style={s().spanH}>
                            {totalTotalQtyApproved}
                        </Text>
                        {unitsExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                            </Text>
                            <Text style={s().spanH}>
                                {totalTotalLaborHoursApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalTotalEquipmentHoursApproved}
                            </Text></View> : null}
                        <Text style={s().spanH}>
                            {totalLaborApproved}
                        </Text>
                        {laborExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalRegularTimeApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalOvertimeApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalBurdenApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalByodApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalPerDiemApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalTruckPayApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalWeldingRigPayApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFieldBonusApproved}
                            </Text>
                        </View> : null}
                        <Text style={s().spanH}>
                            {totalEquipmentApproved}
                        </Text>
                        {equipmentExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalInsideEquipmentRentalsApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalOutsideEquipmentRentalsApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFuelApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalRepairsApproved}
                            </Text>
                            {/* <Text style={s().spanH}>
                    {totalEquipment}
                </Text> */}
                        </View> : null}
                        <Text style={s().spanH}>
                            {totalMaterialsTotalApproved}
                        </Text>
                        {materialsExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalMaterialsApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalMatsApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalToolsSuppliesApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalSkidsApproved}
                            </Text>
                        </View> : null}
                        <Text style={s().spanH}>
                            {totalSubsApproved}
                        </Text>
                        {subsExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalInternalSubsApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalExternalSubsApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalHaulingTransportationApproved}
                            </Text>
                        </View> : null}
                        <Text style={s().spanH}>
                            {totalOtherApproved}
                        </Text>
                        {otherExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalPersonalMealsApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalTeamMealsEntertainApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalAirfareApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalLodgingApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalOtherTravelExpensesApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFieldOfficeRentApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFieldOfficeUtilityApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFieldOfficeExpenseApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalLabFeesTestingApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalSafetyPPEApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalBondsInsurancePremiumsApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalPermitsApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalInsuranceClaimsApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalTaxesApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalAccruedExpensesApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalWarrantyReserveApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalMiscApproved}
                            </Text>
                            <Text style={s().spanH}>
                                {totalOverheadApproved}
                            </Text>
                        </View> : null}
                    </View> : null}
                    <Text style={s().spanH}>
                        {totalTotalCostsApproved}
                    </Text>
                    <Text style={s().spanH}>
                        {totalGrossProfitApproved}
                    </Text>
                    <Text style={s().spanH}>
                        {totalGpPercentApproved}
                    </Text>
                </View>
                <View style={s().container}>
                    <View style={{ width: 360 }}></View>
                    <Text style={s(300).spanH}>
                        Pending Total
                    </Text>
                    <View style={{ width: 20 }}></View>
                    <Text style={s().spanH}>
                        {totalUnitPricePending}
                    </Text>
                    <Text style={s().spanH}>
                        {totalTAndMPending}
                    </Text>
                    <Text style={s().spanH}>
                        {totalChangeOrdersPending}
                    </Text>
                    <Text style={s().spanH}>
                        {totalReductionOfScopePending}
                    </Text>
                    <Text style={s().spanH}>
                        {totalTotalRevenuePending}
                    </Text>
                    <View style={{ width: 20 }}></View>
                    {totalExpanded ? <View style={s().container}>
                        <Text style={s().spanH}>
                            {totalTotalQtyPending}
                        </Text>
                        {unitsExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                            </Text>
                            <Text style={s().spanH}>
                                {totalTotalLaborHoursPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalTotalEquipmentHoursPending}
                            </Text></View> : null}
                        <Text style={s().spanH}>
                            {totalLaborPending}
                        </Text>
                        {laborExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalRegularTimePending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalOvertimePending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalBurdenPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalByodPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalPerDiemPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalTruckPayPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalWeldingRigPayPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFieldBonusPending}
                            </Text>
                        </View> : null}
                        <Text style={s().spanH}>
                            {totalEquipmentPending}
                        </Text>
                        {equipmentExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalInsideEquipmentRentalsPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalOutsideEquipmentRentalsPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFuelPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalRepairsPending}
                            </Text>
                            {/* <Text style={s().spanH}>
                    {totalEquipment}
                </Text> */}
                        </View> : null}
                        <Text style={s().spanH}>
                            {totalMaterialsTotalPending}
                        </Text>
                        {materialsExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalMaterialsPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalMatsPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalToolsSuppliesPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalSkidsPending}
                            </Text>
                        </View> : null}
                        <Text style={s().spanH}>
                            {totalSubsPending}
                        </Text>
                        {subsExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalInternalSubsPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalExternalSubsPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalHaulingTransportationPending}
                            </Text>
                        </View> : null}
                        <Text style={s().spanH}>
                            {totalOtherPending}
                        </Text>
                        {otherExpanded ? <View style={s().container}>
                            <Text style={s().spanH}>
                                {totalPersonalMealsPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalTeamMealsEntertainPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalAirfarePending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalLodgingPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalOtherTravelExpensesPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFieldOfficeRentPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFieldOfficeUtilityPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalFieldOfficeExpensePending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalLabFeesTestingPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalSafetyPPEPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalBondsInsurancePremiumsPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalPermitsPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalInsuranceClaimsPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalTaxesPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalAccruedExpensesPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalWarrantyReservePending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalMiscPending}
                            </Text>
                            <Text style={s().spanH}>
                                {totalOverheadPending}
                            </Text>
                        </View> : null}

                    </View> : null}

                    <Text style={s().spanH}>
                        {totalTotalCostsPending}
                    </Text>
                    <Text style={s().spanH}>
                        {totalGrossProfitPending}
                    </Text>
                    <Text style={s().spanH}>
                        {totalGpPercentPending}
                    </Text>
                </View>
            </View>
        )
    }

    const longFormKeys = [
        { key: 'In JDE', value: 'Any' },
        { key: 'CO No', value: 'Any' },
        { key: 'Phase', value: 'Any' },
        { key: 'Item Description', value: 'Any' },
        { key: 'Status', value: 'Pending, Approved, Final' },
        { key: 'Unit Price', value: 'Number' },
        { key: 'T&M', value: 'Number' },
        { key: 'Change Orders', value: 'Number' },
        { key: 'Reduction of Scope', value: 'Number' },
        { key: 'Total Revenue', value: 'Number' },
        { key: 'budgetQty', value: 'Number' },
        { key: 'totalLaborHours', value: 'Number' },
        { key: 'totalEquipmentHours', value: 'Number' },
        { key: '51100', value: 'Number' },
        { key: '51200', value: 'Number' },
        { key: '51300', value: 'Number' },
        { key: '51400', value: 'Number' },
        { key: '51500', value: 'Number' },
        { key: '51600', value: 'Number' },
        { key: '51700', value: 'Number' },
        { key: '51800', value: 'Number' },
        { key: '52100', value: 'Number' },
        { key: '52200', value: 'Number' },
        { key: '52300', value: 'Number' },
        { key: '52400', value: 'Number' },
        { key: '53100', value: 'Number' },
        { key: '53200', value: 'Number' },
        { key: '53300', value: 'Number' },
        { key: '53400', value: 'Number' },
        { key: '54100', value: 'Number' },
        { key: '54200', value: 'Number' },
        { key: '54300', value: 'Number' },
        { key: '55100', value: 'Number' },
        { key: '55200', value: 'Number' },
        { key: '55300', value: 'Number' },
        { key: '55400', value: 'Number' },
        { key: '56100', value: 'Number' },
        { key: '56200', value: 'Number' },
        { key: '56300', value: 'Number' },
        { key: '56400', value: 'Number' }

    ]

    return (
        <View>
            <View style={{ backgroundColor: '#fff3cd', borderWidth: 1, borderColor: '#ffc107', borderRadius: 5, padding: 12, margin: 20, marginBottom: 10, flexDirection: 'row', alignItems: 'center' }}>
                <Text style={{ color: '#856404', fontSize: 14, fontWeight: '500' }}>
                    ⚠️ Warning: Any changes made to the old format won't be reflected in Forecast/Summary. All changes must be made through Excel upload.
                </Text>
            </View>
            <View style={{ backgroundColor: '#fff', paddingLeft: 20, flexDirection: 'row', flex: 1, minWidth: pageWidth - 300 }}>
                <View style={{ flexDirection: 'row', padding: 5 }}>
                    <Pressable
                        style={{
                            alignItems: 'center',
                            backgroundColor: '#f8fafc',
                            padding: 12,
                            paddingHorizontal: 16,
                            borderRadius: 6,
                            flexDirection: 'row',
                            border: '1px solid #cbd5e1',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                        }}
                        onPress={() => !isExporting && exportCOLogsToExcel(coLogs)}
                        disabled={isExporting}
                    >
                        <Text style={{ color: '#334155', fontWeight: '500', fontSize: 14 }}>                                
                            {isExporting ? 'Exporting...' : 'Export Excel'}
                        </Text>
                    </Pressable>
                    <Pressable
                        style={{
                            alignItems: 'center',
                            backgroundColor: '#f0fdf4',
                            padding: 12,
                            paddingHorizontal: 16,
                            borderRadius: 6,
                            flexDirection: 'row',
                            border: '1px solid #86efac',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                            marginLeft: 10,
                        }}
                        onPress={() => {
                            const coId = prompt('Enter CO ID to verify (leave empty to check all):');
                            verifyStatusForChangeOrder(coId || null);
                        }}
                    >
                        <Text style={{ color: '#166534', fontWeight: '500', fontSize: 14 }}>                                
                            Verify CO Status
                        </Text>
                    </Pressable>
                    <Pressable
                        style={{
                            alignItems: 'center',
                            backgroundColor: isCopying ? '#f1f5f9' : '#3b82f6',
                            padding: 12,
                            paddingHorizontal: 16,
                            borderRadius: 6,
                            flexDirection: 'row',
                            border: '1px solid #2563eb',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                            marginLeft: 10,
                            opacity: isCopying ? 0.6 : 1,
                        }}
                        onPress={() => !isCopying && bulkCopyActiveJobs()}
                        disabled={isCopying}
                    >
                        <Text style={{ color: isCopying ? '#64748b' : 'white', fontWeight: '500', fontSize: 14 }}>
                            {isCopying ? 'Copying...' : 'Copy CO Log → Change Order'}
                        </Text>
                    </Pressable>
                    <Pressable
                        style={{
                            alignItems: 'center',
                            borderColor: '#cfd3d5',
                            borderWidth: 1,
                            borderRadius: 8,
                            justifyContent: 'center',
                            paddingHorizontal: 8,
                            paddingVertical: 12,
                            marginLeft: 10,
                            backgroundColor: isUploading ? '#f5f5f5' : 'transparent',
                            opacity: isUploading ? 0.6 : 1,
                        }}
                        onPress={() => !isUploading && fileInput.current.click()}
                        disabled={isUploading}
                    >
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            {isUploading && (
                                <View style={{ marginRight: 6, animation: 'spin 1s linear infinite' }}>
                                    <Icon3
                                        name="MdRefresh"
                                        size={16}
                                        color="#192440"
                                    />
                                </View>
                            )}
                            <Text style={{ fontSize: 14, color: '#192440' }}>
                                {isUploading ? 'Processing...' : 'Import Excel'}
                            </Text>
                        </View>
                    </Pressable>
                    <input type="file" ref={fileInput}
                        style={{ display: 'none', height: 0, width: 0 }}
                        onChange={fileSelectedHandler} accept=".xlsx" />
                </View>
            </View>
            <View style={{ backgroundColor: 'white', borderRadius: 5, padding: 20, margin: 30, marginBottom: 100, position: 'relative', shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 }}>
                {isUploading && (
                    <View style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                        borderRadius: 5,
                    }}>
                        <View style={{ alignItems: 'center' }}>
                            <Animated.View style={{ transform: [{ rotate: uploadSpin }], marginBottom: 10 }}>
                                <Icon3 name="MdRefresh" size={32} color="#192440" />
                            </Animated.View>
                            <Text style={{ fontSize: 16, color: '#192440', fontWeight: '500' }}>
                                Processing Excel file...
                            </Text>
                            <Text style={{ fontSize: 14, color: '#666', marginTop: 5 }}>
                                Please wait while we import and save your data
                            </Text>
                        </View>
                    </View>
                )}
                <View ref={cologRef} style={{ flexDirection: 'column', maxWidth: 'unset' }}>
                    <View ref={sectionRefs.current[0]}>
                        <Header />
                        {!headersOnly && coLogs ? coLogs.map((co, i) => (
                            <CORow key={i} id={co.id} />
                        )) : null}
                        {headersOnly && coSections ? coSections.map((co, i) => (
                            <CORow header={true} key={i} id={co.id} />
                        )) : null}
                        {headersOnly ? null : <CORow highlighted={true} />}
                        <Footer />
                    </View>
                </View>
            </View>
        </View>
    );
};

export default COLog;